export default Object.freeze({
  A_LAYOUT_WITH_THAT_NAME_ALREADY_EXISTS: "Det finns redan en layout med det namnet",
  ACCEPT: "Acceptera",
  ACCEPT_ALL: "Acceptera alla",
  ACCEPT_REJECT_TRANSFER_PENDING: "Godk\xE4nnande v\xE4ntar",
  ACCEPTED: "Accepterad",
  ACCOUNT: "Konto",
  ACCOUNT_ADDRESS: "Kontoadress",
  ACCOUNT_COUNTRY: "Kontoland",
  ACCOUNT_END: "Kontoslut",
  ACCOUNT_NAME: "Kontonamn",
  ACCOUNT_NUMBER: "Kontonummer",
  ACCOUNT_NUMBER_REQUIRED: "Kr\xE4ver kontonummer",
  ACCOUNTS: "Konton",
  ACCUMULATED_DAYS_ON_RENT: "Ackumulerade dagar p\xE5 hyra",
  ACCUMULATED_DAYS_RENTED: "Ackumulerade uthyrda dagar",
  ACTIONS: "\xC5tg\xE4rder",
  ACTIVE_WARRANTY: "Aktiv garanti",
  ACTIVE_WARRANTY_CLICK_FOR_DETAIL: "Aktiv garanti (klicka f\xF6r detaljer)",
  ACTUAL_AUDIT: "Verklig granskning",
  ACTUAL_AUDIT_DATE: "Verkligt granskningsdatum",
  ACTUAL_COURIER_NAME: "Aktuellt transport\xF6rens namn",
  ACTUAL_HOURS: "Verkliga timmar",
  ADD_CLAIM: "L\xE4gg till anspr\xE5k",
  ADD_CLAIMS: "L\xE4gg till anspr\xE5k",
  ADD_COMPONENT: "L\xE4gg till komponent",
  ADD_OPTION: "L\xE4gg till alternativ",
  ADD_REP: "Ytterligare reparation",
  ADD_TO_AUDIT: "L\xE4gg till i granskning",
  ADDITIONAL: "Ytterligare",
  ADDITIONAL_COMMENTS: "Ytterligare kommentarer",
  ADDITIONAL_REPAIR: "Ytterligare reparation",
  ADDITIVE: "Tillsats",
  ADDRESS: "Adress",
  ADDRESS_LINE1: "Adressrad 1",
  ADDRESS_LINE1_REQUIRED: "Adressrad 1 kr\xE4vs",
  ADDRESS_LINE2: "Adressrad 2",
  ADJ_CLM: "Justera anspr\xE5k",
  ADJUST_CLAIM: "Justera anspr\xE5k",
  ADJUSTED_HOURS: "Justerade timmar",
  ADJUSTED_QUANTITY: "Justerad kvantitet",
  ADJUSTMENT_TYPE: "Justeringstyp",
  ADVANCED_CLAIM_SUMMARY: "Avancerad anspr\xE5kssammanfattning",
  AFTER_DELIVERY_INSPECTION: "EFTER LEVERANSINSPEKTION",
  AGENCY_NAME: "Myndighetens namn",
  ALL: "Alla",
  ALL_ACCOUNTS: "Alla konton",
  ALL_CLAIMS: "Alla anspr\xE5k",
  ALL_CLAIMS_ARE_SUBJECT_TO_REVIEW: "Alla anspr\xE5k kan granskas (se JD WAM 110.08 f\xF6r mer information)",
  ALL_CLAIMS_TAB: "Alla anspr\xE5k ({count, number})",
  ALL_PART_REQUESTS: "Alla reservdelsf\xF6rfr\xE5gningar",
  ALL_PART_REQUESTS_WITH_COUNT: "Alla reservdelsf\xF6rfr\xE5gningar ({count})",
  ALL_PARTS_RETURNED: "Alla reservdelar returnerade",
  AMOUNT: "Belopp",
  AMOUNT_1: "Belopp 1",
  AMOUNT_2: "Belopp 2",
  AMOUNT_3: "Belopp 3",
  AMOUNT_OF_USE: "Anv\xE4ndningsm\xE4ngd",
  AMOUNT_OF_USE_HISTORY_WITH_COUNT: "Anv\xE4ndningshistorik ({count})",
  AMOUNT_OF_USE_IS_REQUIRED: "M\xE4ngd som kr\xE4vs f\xF6r anv\xE4ndning",
  AMOUNT_OF_USE_REQUIRED: "M\xE4ngd anv\xE4ndning som kr\xE4vs",
  AMOUNT_OF_USE_UNITS_REQUIRED: "Antal f\xF6rbrukningsenheter som kr\xE4vs",
  AMOUNT_RECORDED: "Antecknat belopp",
  AMOUNT_TO_BE_DEBITED: "Belopp som skall debiteras",
  APLYPIP: "Till\xE4mpa PIP",
  APPLICATION: "Till\xE4mpning",
  APPLICATION_IS_REQUIRED: "Till\xE4mpning kr\xE4vs",
  APPLY: "Till\xE4mpa",
  APPLY_TRAVEL: "Till\xE4mpa k\xF6rning",
  APPROVAL_DEALER_COMMENTS: "Godk\xE4nnande\xE5terf\xF6rs\xE4ljarens kommentarer",
  APPROVAL_DETAILS: "Godk\xE4nnandeuppgifter",
  APPROVAL_LEVELS: "Godk\xE4nnandeniv\xE5er",
  APPROVAL_REMARKS: "Godk\xE4nnandeanm\xE4rkningar",
  APPROVAL_STATUS: "Godk\xE4nnandestatus",
  APPROVE: "Godk\xE4nn",
  APPROVE_LABOR_RATE: "Godk\xE4nn arbetshastighet",
  APPROVE_MACHINE_STATUS_UPDATE: "Godk\xE4nn uppdatering av maskinstatus",
  APPROVE_PIP_CODE_REQUEST: "Godk\xE4nn PIP-kodsbeg\xE4ran",
  APPROVE_SPECIAL_ALLOWANCE_CLAIM: "Godk\xE4nn anspr\xE5k p\xE5 s\xE4rskild ers\xE4ttning",
  APPROVED: "Godk\xE4nd",
  APPROVED_CORE_VALUE: "Godk\xE4nt k\xE4rnv\xE4rde",
  APPROVED_DATE_CANNOT_BE_BEFORE_SETUP_DATE: "Godk\xE4nt datum kan inte vara f\xF6re inst\xE4llningsdatum",
  APPROVED_DIAGNOSTIC_AMOUNT: "Godk\xE4nd fels\xF6kningsm\xE4ngd",
  APPROVED_DIAGNOSTIC_HOURS: "Godk\xE4nda fels\xF6kningstimmar",
  APPROVED_IS_REQUIRED: "Godk\xE4nd kr\xE4vs",
  APPROVED_LABOR_ADDITIVE: "Godk\xE4nd arbetstillsats",
  APPROVED_LABOR_AMOUNT: "Godk\xE4nd arbetsm\xE4ngd",
  APPROVED_LABOR_HOURS: "Godk\xE4nda arbetstimmar",
  APPROVED_LABOR_TOTAL: "Godk\xE4nd arbetskostnad totalt",
  APPROVED_ON_SHELF_COST: "Godk\xE4nd f\xF6r hyllkostnader",
  APPROVED_OTHER_CREDITS: "Godk\xE4nda andra krediter",
  APPROVED_PARTS: "Godk\xE4nda delar",
  APPROVED_PARTS_ADDITIVE: "Godk\xE4nd reservdelstillsats",
  APPROVED_PARTS_TOTAL: "Godk\xE4nda reservdelar totalt",
  APPROVED_REJECTED: "Godk\xE4nd/avvisad",
  APPROVED_REPAIR_AMOUNT: "Godk\xE4nd reparationsm\xE4ngd",
  APPROVED_REPAIR_HOURS: "Godk\xE4nda reparationstimmar",
  APPROVED_TAXES_TOTAL: "Godk\xE4nda skatter totalt",
  APPROVED_TRAVEL_TOTAL: "Godk\xE4nd total k\xF6rning",
  APPROVER: "Godk\xE4nnare",
  ASCENDING: "stigande",
  ATTACHMENTS: "Tillbeh\xF6r",
  AUDIT_NUMBER: "Revisionsnummer",
  AUDIT_PLANNED: "Planerad granskning",
  AUDIT_REQUIREMENT: "Krav p\xE5 revision",
  AUDIT_RESULTS: "Granskningsresultat",
  AUDIT_STATUS: "Granskningsstatus",
  AUDIT_SUBMITTED_SUCCESSFULLY: "Granskningen har skickats",
  AUDIT_SUMMARY: "Granskningssammanfattning",
  AUDIT_TYPE: "Granskningstyp",
  AUDITS: "Granskningar",
  AUDITS_DUE_WITH_COUNT: "{countToDisplay} granskningar f\xF6rfaller",
  AUDITS_DUE_WITHIN_30_DAYS: "{countToDisplay} {count, plural, one {audit} other {udit}} f\xF6rfaller inom 30 dagar",
  AUDITS_PAST_DUE_WITH_COUNT: "{countToDisplay} {count, plural, one {audit} other {audit}} f\xF6rfaller",
  AUTHORIZATION_NUMBER: "Auktoriseringsnummer",
  AUTO_SUBMIT_FROM_DEALER_BUSINESS_SYSTEM: "Auto Submit (skicka) fr\xE5n \xE5terf\xF6rs\xE4ljarens aff\xE4rssystem",
  AVAILABLE: "TILLG\xC4NGLIG",
  AVAILABLE_COLUMNS: "Tillg\xE4ngliga kolumner",
  AVERAGE_DIAGNOSTICS_HOURS: "Genomsnittliga fels\xF6kningstimmar",
  AVERAGE_LUG_HEIGHT: "Genomsnittlig stopph\xF6jd",
  AVERAGE_LUG_HEIGHT_IS_REQUIRED: "Genomsnittlig stopph\xF6jd kr\xE4vs",
  AVERAGE_REPAIR_HOURS: "Genomsnittliga reparationstimmar",
  AVERAGE_REPLACEMENT_HOURS: "Genomsnittliga utbytestimmar",
  AVERAGE_TECH_PAY_RATE: "Genomsnittlig Tech-betalningshastighet",
  BACK: "Tillbaka",
  BACK_TO_AUDIT: "Tillbaka till granskning",
  BASE_MACHINE: "Basmaskin",
  BASE_MACHINE_IMPLEMENTS: "Basmaskinredskap",
  BASE_MACHINE_PIN: "Basmaskin-PIN",
  BASIC_WARRANTY_ENDS: "Grundl\xE4ggande garanti\xE4ndar",
  BASIC_WARRANTY_ESTIMATOR: "Grundl\xE4ggande garantianspr\xE5k",
  BASIC_WARRANTY_STARTS: "Grundl\xE4ggande garantistart",
  BASIS_FOR_SETTLEMENT: "Grund f\xF6r avveckling",
  BASIS_FOR_SETTLEMENT_AUDIT_COMMENTS: "Grund f\xF6r avveckling / granskningkommentarer",
  BASIS_FOR_SETTLEMENT_IS_REQUIRED: "Grundl\xE4ggande f\xF6r avveckling kr\xE4vs",
  BATTERY: "Batteri",
  BEGIN_DATE: "Startdatum",
  BRANCH: "F\xF6rgrening",
  BUILT: "Byggd",
  BUSINESS_END: "Aff\xE4rs\xE4nda",
  CAN_THE_MACHINE_BE_PUT_BACK_INTO_SERVICE: "Kan maskinen tas i bruk igen?",
  CANCEL: "Avbryt",
  CERTIFIED_LETTER_SENT: "Certifierat brev skickat",
  CGST: "CGST",
  CHANGE_RESPONSIBLE_DEALER: "Byt ansvarig \xE5terf\xF6rs\xE4ljare",
  CHANGE_STATUS: "\xC4ndra status",
  CHANGE_STATUS_FOR: "\xC4ndra status f\xF6r {pin}",
  CHANGED: "\xC4ndrad",
  CHANGED_BY: "\xC4ndrad av",
  CHANGED_ON: "\xC4ndrad den",
  CHINESE: "Kinesiska",
  CITY: "Ort",
  CITY_REQUIRED: "Ort som kr\xE4vs",
  CLAIM: "Anspr\xE5k",
  CLAIM_COUNT_WITH_PARENTHESIS: "({countToDisplay} {count, plural, one {Claim} other {Claims})",
  CLAIM_DEBIT: "Anspr\xE5ksavveckling",
  CLAIM_DETAILS: "Anspr\xE5ksdetaljer",
  CLAIM_DRAFT: "Utkast",
  CLAIM_HISTORY: "24 m\xE5naders anspr\xE5kshistorik",
  CLAIM_HISTORY_WITH_COUNT: "24 m\xE5naders anspr\xE5kshistorik ({count})",
  CLAIM_NUMBER: "Anspr\xE5ksnummer",
  CLAIM_RECOVER_PERCENTAGE: "({procent}%)",
  CLAIM_SEARCH: "Anspr\xE5kss\xF6kning",
  CLAIM_STATUS: "Anspr\xE5ksstatus",
  CLAIM_TYPE: "Anspr\xE5kstyp",
  CLAIM_TYPES: "Typer av anspr\xE5k",
  CLAIM_UPDATED_SUCCESSFULLY: "Anspr\xE5ket har uppdaterats",
  CLAIM_VALUE: "Anspr\xE5ksv\xE4rde",
  CLAIM_VALUE_DETAILS: "Detaljer om anspr\xE5ksv\xE4rde",
  CLAIM_WITH_NUMBER: "Anspr\xE5k {anspr\xE5kNumber}",
  CLAIMS: "Fordringar",
  CLAIMS_IN_PROGRESS: "P\xE5st\xE5enden p\xE5g\xE5r",
  CLAIMS_IN_PROGRESS_WITH_COUNT: "P\xE5st\xE5enden p\xE5g\xE5r ({count})",
  CLAIMS_OVERVIEW: "\xD6versikt \xF6ver anspr\xE5k",
  CLAIMS_OVERVIEW_TAB: "Anspr\xE5ks\xF6versikt ({count})",
  CLAIMS_WITH_COUNT: "{antal} anspr\xE5k",
  CLICK_FOR_DETAILS: "(Klicka f\xF6r detaljer)",
  CLICK_TO_VIEW_ALL: "Klicka f\xF6r att visa alla",
  CLOSE: "St\xE4ng",
  CLOSED_PART_REQUESTS: "Beg\xE4ran om sluten del",
  CLOSING: "St\xE4ngning",
  CLOSING_ACCOUNT: "Avslutande konto",
  CLOSING_ACCOUNT_WITH_COUNT: "Avslutande konto ({count})",
  CODE: "Kod",
  COLLAPSE_ALL: "F\xF6rkorta alla",
  COMMENT: "Kommentera",
  COMMENTS: "Kommentarer",
  COMMENTS_IS_REQUIRED: "Kommentarer kr\xE4vs",
  COMMENTS_TO_DEALER: "Kommentarer till \xE5terf\xF6rs\xE4ljaren",
  COMMON_LABOR_TYPES_WARNING: "Inte alla arbetstyper tillg\xE4ngliga f\xF6r de valda kontona",
  COMPANY: "F\xF6retag",
  COMPANY_CONTRIBUTION: "F\xF6retagsbidrag",
  COMPANY_CONTRIBUTION_IS_REQUIRED: "F\xF6retagsbidrag kr\xE4vs",
  COMPLAINT_CAUSE: "Vad var orsaken till klagom\xE5let?",
  COMPLAINT_CAUSE_IS_REQUIRED: "Orsaken till klagom\xE5let \xE4r n\xF6dv\xE4ndig",
  COMPLAINT_CORRECTION: "Hur r\xE4ttades klagom\xE5let till?",
  COMPLAINT_CORRECTION_IS_REQUIRED: "Korrigering av klagom\xE5l kr\xE4vs",
  COMPLETE: "Komplett",
  COMPLETED: "Slutf\xF6rt",
  COMPLETED_BY: "Slutf\xF6rd av",
  COMPLETED_DATE: "Slutf\xF6rd den",
  COMPLETED_IN_LAST_24_MONTHS: "Slutf\xF6rt de senaste 24 m\xE5naderna",
  COMPLETION_STATUS: "Slutf\xF6randestatus",
  COMPONENT: "Komponent",
  COMPONENT_CODE: "Komponentkod",
  COMPONENT_CREATED_SUCCESSFULLY: "Komponent skapad",
  COMPONENT_DELETED_SUCCESSFULLY: "Komponenten har raderats",
  COMPONENT_SERIAL_NUMBER: "Komponentens serienummer",
  COMPONENT_SUCCESSFULLY_UPDATED: "Komponenten har uppdaterats",
  COMPONENTS: "Komponenter",
  CONFIRM: "Bekr\xE4fta",
  CONFIRM_ADDITIONAL_REPAIR: "\xC4r du s\xE4ker p\xE5 att du vill l\xE4gga till en ytterligare reparation?",
  CONFIRM_ADJUST_CLAIM: "\xC4r du s\xE4ker p\xE5 att du vill justera detta anspr\xE5k?",
  CONFIRM_CLOSING_ACCOUNT: "\xC4r du s\xE4ker p\xE5 att du vill acceptera denna \xF6verf\xF6ring?",
  CONFIRM_COPY_CLAIM: "\xC4r du s\xE4ker p\xE5 att du vill kopiera detta anspr\xE5k?",
  CONFIRM_DELETE_ATTACHMENT: "\xC4r du s\xE4ker p\xE5 att du vill ta bort den h\xE4r bilagan?",
  CONFIRM_DELETE_CLAIM: "\xC4r du s\xE4ker p\xE5 att du vill radera detta anspr\xE5k?",
  CONFIRM_DELETE_REGISTRATION: "\xC4r du s\xE4ker p\xE5 att du vill ta bort denna registrering?",
  CONFIRM_EDIT_CLAIM: "\xC4r du s\xE4ker p\xE5 att du vill redigera detta anspr\xE5k?",
  CONFIRM_RECONCILE_CLAIM: "\xC4r du s\xE4ker p\xE5 att du vill f\xF6rena detta p\xE5st\xE5ende?",
  CONFIRM_RESEND_XML: "\xC4r du s\xE4ker p\xE5 att du vill skicka om XML? V\xE4nta 24-48 timmar f\xF6r att den ska synas.",
  CONFIRM_SKIP_AUDIT: "\xC4r du s\xE4ker p\xE5 att du vill hoppa \xF6ver denna granskning?",
  CONFIRM_UNDO_REGISTRATION: "\xC4r du s\xE4ker p\xE5 att du vill \xE5ngra denna registrering?",
  CONTACTED: "Kontaktad",
  CONTAINS: "Inneh\xE5ller",
  CONTRACT_NUMBER: "Kontraktsnummer",
  CONTRACT_PURCHASED: "K\xF6pt av kontrakt",
  CONTRACT_TYPE: "Kontraktstyp",
  COPY_CLAIM: "Kopiera anspr\xE5k",
  CORE: "K\xE4rna",
  CORE_VALUE: "K\xE4rnv\xE4rde",
  COUNTRY: "Land",
  COUNTRY_REQUIRED: "Kr\xE4ver land",
  COURIER_ACCOUNT_NUMBER: "Kontonummer f\xF6r kontingenter",
  COURIER_NAME: "Transport\xF6rens namn",
  COVERAGE_DECISION: "T\xE4ckningsbeslut",
  COVERAGE_TYPE: "Typ av t\xE4ckning",
  CRDMEM: "Kreditnota",
  CREATE: "Skapa",
  CREATE_CLAIM: "Skapa anspr\xE5k",
  CREATE_LAYOUT: "Skapa layout",
  CREATE_NON_TRACKED_PIN_HELP_TEXT: "Innan du kan g\xF6ra ett anspr\xE5k p\xE5 den h\xE4r produkten m\xE5ste du ber\xE4tta f\xF6r oss om viktig information om den",
  CREATE_PIP_CLAIM: "Skapa PIP-anspr\xE5k",
  CREATE_PIP_CLAIMS: "Skapa PIP-anspr\xE5k",
  CREATE_PRODUCT_RECORD: "Skapa produktregister",
  CREATE_REQUEST: "Skapa beg\xE4ran",
  CREATE_TRANSFER_PENDING: "\xD6verf\xF6ringen p\xE5g\xE5r",
  CREATE_TRANSFER_SERVICE_UNAVAILABLE: "Skapa \xF6verf\xF6ringsservice ej tillg\xE4nglig",
  CREATED: "Skapad",
  CREATED_BY: "Skapad av",
  CREATED_DATE: "Skapad den",
  CREATED_ON: "Skapad den",
  CREATION_DATE: "Skapandedatum",
  CREDIT_MEMO: "Kreditnota",
  CREDIT_MEMO_DATE: "Kreditnotsdatum",
  CREDIT_MEMO_ISSUE_DATE: "Utf\xE4rdad kreditnota",
  CREDIT_MEMO_NUMBER: "Nummer p\xE5 kreditnota",
  CREDIT_MEMO_PROCESS_DATE: "Behandlad kreditnota",
  CREDIT_MEMO_SELECTED: "Vald kreditnota",
  CREDIT_MEMOS: "Kreditnotor",
  CRITERIA: "Kriterier",
  CRT: "Skapa",
  CSV_SEPARATOR: "CSV-separator",
  CURRENCY: "Valuta",
  CURRENT: "Aktuell",
  CURRENT_ACCOUNT: "Aktuellt konto",
  CURRENT_AMOUNT_OF_USE: "Aktuell anv\xE4ndningsm\xE4ngd",
  CURRENT_CUSTOMER: "Aktuell kund",
  CURRENT_DEALER: "Aktuell \xE5terf\xF6rs\xE4ljare",
  CURRENT_DEALER_DISTANCE: "Aktuellt f\xF6rs\xE4ljningsavst\xE5nd",
  CURRENT_DEALER_LAST_SERVICE_DATE: "Aktuellt senaste servicedatum f\xF6r \xE5terf\xF6rs\xE4ljare",
  CURRENT_DEALER_LOCATION: "Aktuell \xE5terf\xF6rs\xE4ljarplats",
  CURRENT_HOURS: "Aktuella timmar",
  CURRENT_QUANTITY: "Nykyinen m\xE4\xE4r\xE4",
  CURRENT_RESPONSIBLE_DEALER: "Aktuell ansvarig \xE5terf\xF6rs\xE4ljare",
  CURRENT_VALUES: "Aktuella v\xE4rden",
  CURRENTLY_ON_RENT: "F\xF6r n\xE4rvarande p\xE5 hyra",
  CUSTOM_RANGE: "Anpassat omr\xE5de",
  CUSTOM_VALUES: "Anpassade v\xE4rden",
  CUSTOMER: "Kund",
  CUSTOMER_CONTRIBUTION: "Kundbidrag",
  CUSTOMER_CONTRIBUTION_IS_REQUIRED: "Kundbidrag kr\xE4vs",
  CUSTOMER_CREATED_SUCCESSFULLY: "Kunden har skapats",
  CUSTOMER_DETAILS: "Kundinformation",
  CUSTOMER_DETAILS_UPDATED_SUCCESSFULLY: "Kundinformation har uppdaterats",
  CUSTOMER_INFORMATION: "Kundinformation",
  CUSTOMER_INFORMATION_IS_REQUIRED: "Kundinformation kr\xE4vs.",
  CUSTOMER_INVALID: "Kunden kunde inte hittas eller skapas, s\xF6k efter en kund",
  CUSTOMER_NAME: "Kundnamn",
  CUSTOMER_NAME_IS_REQUIRED: "Kundnamn kr\xE4vs.",
  CUSTOMER_NOT_FOUND: "Kunden hittades inte",
  CUSTOMER_REQUIRED: "Kr\xE4ver kund",
  CUSTOMER_RESOLUTION: "Kundl\xF6sning",
  CUSTOMER_RESOLUTION_IS_REQUIRED: "Kundl\xF6sning kr\xE4vs",
  CUSTOMER_SEARCH: "Kunds\xF6kning",
  CUSTOMER_UPDATED_SUCCESSFULLY: "Kunden har uppdaterats",
  DAMAGED_MACHINES_HELP_TEXT: "F\xF6r skadade maskiner kommer garantin automatiskt att dras in tills detta formul\xE4r granskas och godk\xE4nns av TCSM f\xF6r att \xE5terst\xE4lla garantin. Skadade maskiner uppfyller endast kraven f\xF6r obligatoriska och s\xE4kerhets-PIP.",
  DATE: "Datum",
  DATE_FORMAT: "Datumformat",
  DATE_ISSUED: "Utf\xE4rdandedatum",
  DATE_OF_CERTIFIED_LETTER: "Datum f\xF6r bestyrkt brev",
  DATE_OF_EVENT_CAUSING_DAMAGE: "Datum f\xF6r h\xE4ndelse som orsakar skada",
  DATE_OF_LAST_PERSONAL_CONTACT: "Datum f\xF6r senaste personliga kontakt",
  DATE_RECALLED_PART_WAS_SHIPPED_SENT: "Datum d\xE5 den \xE5terkallade delen skickades/skickades",
  DATE_REFUSED: "Datum nekad",
  DATE_SUBMITTED: "Inl\xE4mningsdatum",
  DAYS_FROM_REGISTRATION: "Dagar fr\xE5n registrering",
  DAYS_LEFT: "V\xE4nster dag",
  DAYS_LEFT_WITH_COUNT: "{daysToDisplay} {days, plural, one {Day} other {Days} Left}",
  DAYS_ON_RENT: "Antal hyrda dagar",
  DAYS_REMAINING: "\xC5terst\xE5ende dagar",
  DAYS_REMAINING_WITH_COUNT: "{daysToDisplay} {days, plural, one {Day} other {Days} \xC5terst\xE5ende",
  DAYS_TO_DISPLAY: "Dagar att visa",
  DBS: "DBS",
  DEALER: "\xC5terf\xF6rs\xE4ljare",
  DEALER_ACCOUNT: "\xC5terf\xF6rs\xE4ljarkonto",
  DEALER_ACCOUNT_IS_REQUIRED: "\xC5terf\xF6rs\xE4ljarkonto kr\xE4vs",
  DEALER_ACCOUNTS: "\xC5terf\xF6rs\xE4ljarkonton",
  DEALER_CITY: "\xC5terf\xF6rs\xE4ljarens stad",
  DEALER_COMMENTS: "\xC5terf\xF6rs\xE4ljarens kommentarer",
  DEALER_CONTRIBUTION: "\xC5terf\xF6rs\xE4ljarbidrag",
  DEALER_CONTRIBUTION_IS_REQUIRED: "\xC5terf\xF6rs\xE4ljarbidrag kr\xE4vs",
  DEALER_HIERARCHY_ACCOUNT: "{account} ({industryIndicator})",
  DEALER_INVOICE_NUMBER: "\xC5terf\xF6rs\xE4ljarens fakturanummer",
  DEALER_INVOICE_UPDATED: "\xC5terf\xF6rs\xE4ljarfaktura uppdaterad",
  DEALER_INVOICE_UPDATES: "\xC5terf\xF6rs\xE4ljarfaktura",
  DEALER_INVOICES: "\xC5terf\xF6rs\xE4ljarfakturor",
  DEALER_LOCATION: "\xC5terf\xF6rs\xE4ljarens placering",
  DEALER_LOCATION_FILTER: "Filterplacering",
  DEALER_LOCATION_IS_REQUIRED: "\xC5terf\xF6rs\xE4ljarens placering kr\xE4vs",
  DEALER_LOCATIONS: "\xC5terf\xF6rs\xE4ljarplatser",
  DEALER_NAME: "\xC5terf\xF6rs\xE4ljarens namn",
  DEALER_PHONE: "\xC5terf\xF6rs\xE4ljarens telefon",
  DEALER_POSTAL_CODE: "\xC5terf\xF6rs\xE4ljarens postnummer",
  DEALER_RECOMMENDATIONS: "Handlarrekommendationer",
  DEALER_RECOMMENDATIONS_TAB: "Handlarrekommendationer ({count})",
  DEALER_REVIEW_REQUEST_SUCCESSFULLY: "\xC5terf\xF6rs\xE4ljaren har granskats",
  DEALER_SEARCH: "\xC5terf\xF6rs\xE4ljars\xF6kning",
  DEALER_SEARCH_CHOOSE_CITY_NAME_ACCOUNT: "Ange namn, ort eller konto f\xF6r att s\xF6ka efter \xE5terf\xF6rs\xE4ljare",
  DEALER_STATE: "\xC5terf\xF6rs\xE4ljarstatus",
  DEALER_SUBMISSION_WITH_CURRENCY: "\xC5terf\xF6rs\xE4ljars\xE4ndning ({valuta})",
  DEALER_TRANSFER_HISTORY: "\xC5terf\xF6rs\xE4ljarens \xF6verf\xF6ringshistorik",
  DEALER_TRANSFER_REQUEST_SUCCESSFULLY: "Beg\xE4ran om vidare\xF6verf\xF6ring k\xF6ades",
  DEALER_WARRANTY: "\xC5terf\xF6rs\xE4ljargaranti",
  DEALERS: "\xC5terf\xF6rs\xE4ljare",
  DEALERSHIP: "\xC5terf\xF6rs\xE4ljare",
  DEBIT: "Skr\xE4p",
  DEBIT_AMOUNT: "Debetbelopp",
  DEBIT_FOR_CLAIM_NUMBER: "Debit f\xF6r {h\xE4vdarNumber}",
  DEBIT_REQUIRED: "Erforderlig debit",
  DEBIT_REQUIRED_STATUS: "Erforderlig debetstatus",
  DEBIT_SUBMITTED_SUCCESSFULLY: "S\xE4nd inmatning lyckades",
  DEBIT_TYPE: "Typ av indragning",
  DEBITED: "Skuldad",
  DEBITS_TO_THIS_CLAIM_MUST_BE_COMPLETED_THROUGH_MANUAL_DEBIT_PROCESS: "Skulder till detta anspr\xE5k m\xE5ste fyllas i genom den manuella debetprocessen",
  DECIMAL_FORMAT: "Decimalformat",
  DECISION_UPDATED: "Beslutet uppdaterat",
  DECLINE: "Avsl\xE5",
  DEDUCTIBLE: "Avtagbar",
  DEERE_REMARKS: "Deere anm\xE4rkningar",
  DEFAULT_WARRANTY: "Standardgaranti",
  DEL: "Radera",
  DELETE: "Radera",
  DELETE_ATTACHMENT: "Radera bilaga",
  DELETE_CLAIM: "Radera anspr\xE5k",
  DELETE_REGISTRATION: "Radera registrering",
  DELETE_REGISTRATION_SUCCESS: "Registreringsraderingen lyckades",
  DELETED: "Raderad",
  DELETED_BY: "Raderad av",
  DELIVERED: "Levererad",
  DELIVERED_IS_REQUIRED: "Levereras kr\xE4vs",
  DELIVERY_DATE: "Leveransdatum",
  DELIVERY_DATE_REQUIRED: "Leveransdatum kr\xE4vs",
  DELIVERY_DATES: "Leveransdatum",
  DELIVERY_NO_DOCUMENTS: "Leverans, inga dokument",
  DEMO_RENTAL_BEGIN_DATE: "Demo-/uthyrningsstartdatum",
  DEMO_RENTAL_CHOOSE_DEALERS_STATUS: "V\xE4lj \xC5terf\xF6rs\xE4ljare och status",
  DEMO_RENTAL_END_DATE: "Demo-/uthyrningsslutdatum",
  DEMO_RENTAL_HISTORY: "Demonstrationshyrningshistorik",
  DENY: "neka",
  DENY_MACHINE_STATUS_UPDATE: "Uppdatering av nekad maskinstatus",
  DENY_PIP_CODE_REQUEST: "Beg\xE4ran om nekad PIP-kod",
  DESCENDING: "Sjunkande",
  DESCRIPTION: "Beskrivning",
  DESCRIPTION_OF_DAMAGE: "Beskrivning av skador",
  DESCRIPTION_OF_EVENT_CAUSING_DAMAGE: "Beskrivning av h\xE4ndelse som orsakar skada",
  DESELECT_ALL: "Avmarkera allt",
  DETAILS: "Detaljer",
  DIAGNOSTICS_COVERED: "T\xE4ckt fels\xF6kning",
  DIS_VSR: "Monitormeddelanden",
  DISPLAY: "Visning",
  DISPLAY_CLAIM: "Displayanspr\xE5k",
  DISPLAY_CREDIT_MEMO: "Visa kreditnota",
  DISPLAY_FORMAT: "Displayformat",
  DISPLAY_PRODUCT: "Visa produkt",
  DISPLAY_TAG: "Displayetikett",
  DISTANCE: "Avst\xE5nd",
  DISTANCE_FROM_CURRENT_DEALER: "Avst\xE5nd fr\xE5n nuvarande \xE5terf\xF6rs\xE4ljare",
  DISTANCE_FROM_POTENTIAL_DEALER: "Avst\xE5nd fr\xE5n potentiell \xE5terf\xF6rs\xE4ljare",
  DIVISION: "Division",
  DIVISION_SUMMARY: "Sammanfattning av divisionen",
  DO_YOU_WANT_TO_SAVE_YOUR_CHANGES: "Vill du spara dina \xE4ndringar?",
  DOES_NOT_CONTAIN: "Inneh\xE5ller inte",
  DOWNLOAD_TO_EXCEL: "H\xE4mta till Excel",
  DOWNTIME: "Stillest\xE5ndstid",
  DOWNTIME_IS_REQUIRED: "Stillest\xE5ndstid kr\xE4vs",
  DRAFT: "Spara som utkast",
  DTAC_CASE: "DTAC-\xE4rende",
  DTAC_CASE_NUMBER: "DTAC-\xE4rendenummer",
  DTAC_SOLUTION: "DTAC-l\xF6sning",
  DUE_DATE: "F\xF6rfallodatum",
  DUE_WITHIN_3_MONTHS: "Inom 3 m\xE5nader",
  DUPLICATE_PIN_PLATE: "Dubblett av PIN-skylt",
  DUPLICATE_PIN_PLATE_REQUEST_UPDATED: "Dubblett av PIN-pl\xE5tbeg\xE4ran har uppdaterats",
  DUPLICATE_PIN_PLATE_SUCCESSFULLY_CREATED: "Beg\xE4ran om dubbel PIN-platta har skapats",
  DUPLICATE_PIN_PLATE_WITH_COUNT: "Kopiera PIN-pl\xE5tbeg\xE4ran ({count})",
  EDIT: "Redigera",
  EDIT_CUSTOMER: "Redigera kund",
  EDIT_LAYOUT: "Redigera layout",
  EDIT_WITH_PARENTHESES: "(Redigera)",
  EFFECTIVE: "Effektiv",
  EFFECTIVE_DATE: "G\xE4ller fr\xE5n",
  EMAIL: "E-post",
  EMISSIONS_PART_SEARCH: "Utsl\xE4ppsdelss\xF6kning",
  END_DATE: "Slutdatum",
  END_USE: "Slutanv\xE4ndning",
  END_USE_CODE: "Kod f\xF6r slutanv\xE4ndning",
  END_USE_CODE_REQUIRED: "Kod f\xF6r slutanv\xE4ndning kr\xE4vs",
  ENDS_WITH: "\xC4ndar med",
  ENGLISH: "Engelska",
  ENTER_A_NUMBER_BETWEEN_0_AND_1000: "Ange ett v\xE4rde mellan 0 och 1000",
  ENTER_A_NUMBER_BETWEEN_0_AND_10000: "Ange ett v\xE4rde mellan 0 och 10000",
  ENTER_A_NUMBER_FROM_1_TO_9999: "Ange ett nummer mellan 1 och 9999",
  ENTER_A_PART_NUMBER: "Ange ett artikelnummer",
  ENTER_COMMENTS_BEFORE_ACCEPTING: "Ange kommentarer innan du accepterar",
  EQUALS: "Lika med",
  ERROR: "FEL:",
  ERROR_MESSAGE_TITLE: "Ett fel har intr\xE4ffat:",
  ERROR_MESSAGES: "Felmeddelanden",
  ERROR_MESSAGES_TITLE: "Flera fel har intr\xE4ffat:",
  ERROR_NETWORK_ISSUES: "Ett n\xE4tverksfel f\xF6rhindrade att vissa data laddades - f\xF6rs\xF6k igen",
  ERROR_NO_DATA_TO_EXPORT: "Inga data att exportera",
  ERROR_RETRIEVING_CUSTOMER_INFORMATION: "Fel vid h\xE4mtning av kundinformation",
  ERROR_SAP: "Kan inte ansluta till servern.  Om problemet kvarst\xE5r, anv\xE4nd l\xE4nken Kontakta oss f\xF6r att f\xE5 hj\xE4lp med att l\xF6sa problemet.",
  ERROR_SESSION: "Din session har utg\xE5tt.  Uppdatera sidan f\xF6r att logga in igen.",
  ERROR_UNHANDLED: "Systemet p\xE5tr\xE4ffade ett ov\xE4ntat fel.  Om problemet kvarst\xE5r, anv\xE4nd v\xE5r \"Hj\xE4lp\"-funktion eller l\xE4nken \"Kontakta oss\" f\xF6r att f\xE5 hj\xE4lp med att l\xF6sa problemet.",
  ERROR_UPLOADING_FILE: "Filen har inte lagts till",
  ESTIMATED_BASIC_DATE: "Ber\xE4knat basdatum",
  ESTIMATED_BASIC_DAYS: "Ber\xE4knade grunddagar",
  ESTIMATES_MAY_NOT_REFLECT_DEMO_STATUS_OR_HOURS_NOT_YET_REPORTED: "Uppskattningar \xE5terspeglar eventuellt inte demostatus eller timmar som \xE4nnu inte rapporterats",
  EXCEEDS_DEMO_THRESHOLD: "\xD6vertr\xE4ffar demonstrationstr\xF6skel",
  EXCHANGE_RATE: "V\xE4xelkurs",
  EXCLUDED_PINS_ARE_NOT_INCLUDED_IN_THIS_REPORT: "Exkluderade PIN-nummer ing\xE5r inte i detta bet\xE4nkande.",
  EXECUTE: "Utf\xF6r",
  EXPAND_ALL: "Expandera alla",
  EXPECTED_FIRST_USE: "F\xF6rv\xE4ntad f\xF6rsta anv\xE4ndning",
  EXPIRATION_DATE: "Utg\xE5ngsdatum",
  EXPIRED: "Utg\xE5nget",
  EXPIRED_PART_REQUESTS: "Beg\xE4randen om utg\xE5ende reservdel",
  EXPIRED_PIPS: "Utg\xE5ngna PIP:er",
  EXPIRES: "Utg\xE5r",
  EXPIRING_SOON: "F\xF6rfaller snart",
  EXPORT: "Export",
  EXTENDED_WARRANTY: "Ut\xF6kad garanti",
  FACTORY: "FABRIK",
  FACTORY_NAME: "Fabriksnamn",
  FAILED: "Misslyckades",
  FAILED_AREA: "Fel omr\xE5de",
  FAILED_AREA_IS_REQUIRED: "Ett trasigt omr\xE5de kr\xE4vs",
  FAILED_DATE: "Misslyckat datum",
  FAILED_DATE_IS_REQUIRED: "Misslyckat datum kr\xE4vs",
  FAILED_MODE: "Fel-l\xE4ge",
  FAILED_MODE_COMMENTS: "Kommentarer f\xF6r misslyckat l\xE4ge",
  FAILED_PART: "Trasig del",
  FAILED_PART_DESCRIPTION: "Felaktig reservdelsbeskrivning",
  FAILED_PART_IS_A_REMAN_PART: "Misslyckad del \xE4r en ReMan-del",
  FAILED_PART_IS_REQUIRED: "En trasig del kr\xE4vs",
  FAILED_PART_SERIAL: "Fel p\xE5 reservdelsserienummer",
  FAILED_PART_SERIAL_IS_REQUIRED: "En trasig reservdelsserie kr\xE4vs",
  FAILURE_DATE: "Feldatum",
  FAILURE_INFORMATION: "Felinformation",
  FAILURE_MODE: "Fel-l\xE4ge",
  FAILURE_MODE_IS_REQUIRED: "Ett misslyckat l\xE4ge kr\xE4vs",
  FAILURE_PART: "Trasig del",
  FAILURE_PART_DESCRIPTION: "Beskrivning av feldel",
  FAILURE_PART_IS_REQUIRED: "En defekt del kr\xE4vs",
  FAILURE_TO_RETURN_PARTS_WARNING: "Om de efterfr\xE5gade delarna inte returneras kan det leda till en debitering.",
  FAVORITES: "Favoriter",
  FILE_NAME: "Filnamn",
  FILE_SIZE_IS_TOO_BIG: "Filstorleken \xE4r f\xF6r stor (max. storlek: 100 MB)",
  FILE_SIZE_IS_TOO_BIG_CSV: "Filstorleken \xE4r f\xF6r stor (max. storlek: 1 MB)",
  FILE_UPLOAD_MESSAGE: "Sl\xE4pp filer h\xE4r eller klicka f\xF6r att l\xE4gga till filer (max. storlek: 100 MB)",
  FILE_UPLOAD_MESSAGE_CSV: "Sl\xE4pp filer h\xE4r eller klicka f\xF6r att l\xE4gga till filer (max. storlek: 1 MB)",
  FILE_UPLOAD_MESSAGE_IMAGE: "Dra och sl\xE4pp bilder h\xE4r eller klicka f\xF6r att l\xE4gga till bilder (maximal storlek: 100 MB).",
  FILE_UPLOAD_MESSAGE_SINGLE: "Sl\xE4pp en enskild fil h\xE4r eller klicka f\xF6r att l\xE4gga till (max. storlek: 100 MB)",
  FILE_UPLOAD_UNABLE_TO_READ: "Systemet kunde inte l\xE4sa din fil.  J\xE4mf\xF6r den med mallen och f\xF6rs\xF6k igen.",
  FILES: "Filer",
  FILTER_PLACEHOLDER: "Filterresultat",
  FILTER_WITH_ELLIPSIS: "Filter ...",
  FILTERED_BY_COLUMN_ID: "Filtrerad av {kolumnId}",
  FIND_CUSTOMER: "Hitta kund",
  FINNISH: "Finska",
  FIRST_MAINTENANCE: "F\xD6RSTA UNDERH\xC5LL",
  FIRST_NAME: "F\xF6rnamn",
  FIRST_NAME_IS_REQUIRED: "F\xF6rnamn kr\xE4vs",
  FIRST_SHIP_TO_LOCATION: "Levereras f\xF6rst till platsen",
  FIRST_USE: "F\xF6rsta anv\xE4ndningen",
  FISCAL_YEAR: "R\xE4kenskaps\xE5r",
  FLUID_SAMPLING_REQUIRED: "V\xE4tskeprovtagning kr\xE4vs",
  FORWARDED: "Vidarebefordrad",
  FRENCH: "franska",
  FROM: "Fr\xE5n",
  FRWRD: "Fram\xE5t",
  FULL_DEBIT: "Full deplacement",
  GENERAL: "Allm\xE4nt",
  GERMAN: "Tyska",
  GET_MAINTENANCE_PLANS: "F\xE5 underh\xE5llsplaner",
  GOODS_INSTALLATION_VAT: "Merv\xE4rdesskatt vid varuleveransering",
  GRACE_PERIOD: "Nyhetsperiod",
  GREATER_THAN: "St\xF6rre \xE4n",
  GREATER_THAN_OR_EQUALS: "H\xF6gre \xE4n eller lika med",
  GROUP_COMPLETE: "Grupp slutf\xF6rd",
  GST_PERCENTAGE: "GST-procent",
  HISTORY_TO_DISPLAY: "Historik att visa (dagar)",
  HOME: "Startsida",
  HOUR_LIMIT: "Timgr\xE4ns",
  HOURS: "Timmar",
  HOURS_ON_RENT: "Hyra, timmar p\xE5",
  HSN_SAC_CODE: "HSN/SAC-kod",
  IGST: "IGST",
  IMPLEMENTS: "Redskap",
  IN_RANGE: "Inom omr\xE5det",
  INCENTIVE: "Incitament",
  INCENTIVE_PROGRAMS: "Stimulansprogram",
  INCLUDE_FULLY_COMPLETE: "Inkludera komplett PIP:er",
  INDICATES_REQUIRED_FIELD: "Anger obligatoriskt f\xE4lt",
  INFO_MESSAGE_TITLE: "Ett systemmeddelande har skickats:",
  INFO_MESSAGES: "Informationsmeddelanden",
  INFO_MESSAGES_TITLE: "Flera systemmeddelanden har skickats:",
  INFO_REQUEST_STATUS_ERROR: "Informationen kan skickas med denna beg\xE4ran.",
  INFORMATION: "Information",
  INFORMATION_REQUEST: "Beg\xE4ran om information",
  INFORMATION_REQUEST_STATUS: "Status f\xF6r beg\xE4ran om information",
  INPUT_PIN: "Inmatnings-PIN",
  INSPECTION: "Inspektion",
  INSTALLED_BY: "Installerad av",
  INSTALLED_BY_IS_REQUIRED: "Installerad av kr\xE4vs",
  INTERNAL_DEERE_COMMENTS: "Interna Deere-kommentarer",
  INTERVAL_BEGINS: "Intervallet b\xF6rjar",
  INTERVAL_ENDS: "Intervallslut",
  INTERVAL_TYPE_DESCRIPTION: "Beskrivning av intervalltyp",
  INVOICE_ACCOUNT: "Fakturakonto",
  INVOICE_DEALER: "Faktura\xE5terf\xF6rs\xE4ljare",
  INVOICE_NUMBER: "Fakturanummer",
  INVOICE_REQUEST: "Fakturabeg\xE4ran",
  INVOICE_SENT: "Fakturan s\xE4nd",
  INVOICE_UPDATED_SUCCESSFULLY: "Fakturan har uppdaterats",
  INVOICED: "Fakturerad",
  INVOICED_TO: "Fakturerad till",
  IRC_PIN_MESSAGE: "Kunden \xE4r en IRC och har r\xE4tt till extra restid och leage under maskinens f\xF6rsta 500 timmar eller 12 m\xE5nader.",
  ISSUED: "Utgiven",
  ITALIAN: "Italienska",
  ITEM: "Post",
  ITEM_NUMBER: "Artikelnummer",
  ITEM_NUMBER_IS_REQUIRED: "Artikelnummer kr\xE4vs",
  JDLINK_EXPIRES: "JDLink utg\xE5r",
  JDP_COMMENTS: "JDP-kommentarer",
  JDP_COMMENTS_IS_REQUIRED: "JDP-kommentarer kr\xE4vs",
  JDP_CUSTOMER_RESOLUTION: "JDP Kundl\xF6sning",
  JDP_CUSTOMER_RESOLUTION_IS_REQUIRED: "JDP Kundl\xF6sning kr\xE4vs",
  JDP_REASON: "JDP-orsak",
  JDP_REASON_IS_REQUIRED: "JDP-orsak kr\xE4vs",
  LABOR: "Arbete",
  LABOR_ADDITIVE: "Arbetstill\xE4gg",
  LABOR_ADDITIVE_COMPLETION_DETAIL: "Detaljer f\xF6r slutf\xF6rande av till\xE4gg i arbete",
  LABOR_ADDITIVE_PIPS: "PIP f\xF6r till\xE4gg till arbete",
  LABOR_ADDITIVE_TAB: "Arbetstill\xE4gg ({count})",
  LABOR_ADJUSTMENT: "Justering av arbete",
  LABOR_COMMENTS: "Arbetskommentarer",
  LABOR_HOURS: "Arbetstimmar",
  LABOR_ITEM_DETAILS: "Arbete - {quantity} {unit} {description}",
  LABOR_RATE_APPROVED_SUCCESSFULLY: "Godk\xE4nd arbetshastighet lyckades",
  LABOR_RATE_CHANGE_SUBMITTED: "\xC4ndring i arbetshastighet skickad",
  LABOR_RATE_CHANGES_WITH_COUNT: "\xC4ndringar i arbetshastighet ({count})",
  LABOR_RATE_CONFIRM: "Den beg\xE4rda hastigheten \xE4r l\xE4gre \xE4n den nuvarande.  \xC4r du s\xE4ker p\xE5 att du vill skicka in beg\xE4ran?",
  LABOR_RATE_DIFFERENCE_LARGE_INFORMATION_MESSAGE: "V\xE4rdena i den r\xF6da texten tyder p\xE5 en \xF6kning med mer \xE4n 10 % fr\xE5n den befintliga skattesatsen",
  LABOR_RATE_HISTORY: "Arbetshastighetshistorik",
  LABOR_RATE_REJECTED_SUCCESSFULLY: "Arbetshastigheten avvisades framg\xE5ngsrikt",
  LABOR_RATE_REQUESTS_STATUS: "Status f\xF6r beg\xE4ran om arbetshastighet",
  LABOR_RATE_RETURNED_SUCCESSFULLY: "Arbetshastigheten har returnerats",
  LABOR_RATES: "Arbetstakt",
  LABOR_STATS: "Arbetstillst\xE5nd",
  LABOR_TOTAL: "Totalt arbete",
  LABOR_TYPE: "Typ av arbete",
  LABOR_VALUE: "V\xE4rde p\xE5 arbete",
  LABOR_WITH_COUNT: "Arbete ({count})",
  LANGUAGE: "Spr\xE5k",
  LAST_LOCATION_FROM: "Sista platsen fr\xE5n",
  LAST_NAME: "Efternamn",
  LAST_NAME_IS_REQUIRED: "Efternamn kr\xE4vs",
  LAST_PERSONAL_CONTACT: "Senaste personliga kontakt",
  LAW_ENFORCEMENT_AGENCY_DETAILS: "Uppgifter om brottsbek\xE4mpande organ",
  LAYOUT_CREATED_SUCCESSFULLY: "Layout skapad",
  LAYOUT_DELETED_SUCCESSFULLY: "Layout raderad",
  LAYOUT_NAME: "Layoutnamn",
  LAYOUT_UPDATED_SUCCESSFULLY: "Layout uppdaterad",
  LEAD_ACCOUNT: "Ledningskonto",
  LEAD_DEALER: "Ledande \xE5terf\xF6rs\xE4ljare",
  LESS_THAN: "Mindre \xE4n",
  LESS_THAN_OR_EQUALS: "Mindre \xE4n eller lika med",
  LICENSE_PLATE_NUMBER: "Nummer p\xE5 nummerskylt",
  LIFETIME: "Livstid",
  LINE_ITEMS_EXPORT: "Export av radposter",
  LIST: "Lista",
  LIST_TOTAL: "Lista totalt",
  LOCATION: "Placering",
  LOCATION_DUE: "Plats f\xF6rfaller",
  LOCATIONS: "Platser",
  LOCATIONS_WITH_COUNT: "Platser ({count})",
  MACHINE_ALREADY_REGISTERED_TO_THIS_CUSTOMER: "Maskinen \xE4r redan registrerad hos denna kund",
  MACHINE_INFORMATION: "Maskininformation",
  MACHINE_MODEL_TYPE: "Maskinmodell/typ",
  MACHINE_MODEL_TYPE_REQUIRED: "Maskinmodell/typ kr\xE4vs",
  MACHINE_STATUS: "Maskinstatus",
  MACHINE_STATUS_UPDATE_ACCEPTED: "Maskinstatusuppdatering godk\xE4nd",
  MACHINE_STATUS_UPDATE_DOCUMENT: "Uppdateringsdokument f\xF6r maskinstatus",
  MACHINE_STATUS_UPDATE_REJECTED: "Uppdatering av maskinstatus avvisades",
  MACHINE_STATUS_UPDATES_WITH_COUNT: "Maskinstatusuppdateringar ({count})",
  MACHINE_TYPE: "Maskintyp",
  MACHINE_TYPE_IS_REQUIRED: "Maskintyp kr\xE4vs",
  MACHINE_USE: "Maskinanv\xE4ndning",
  MAILING_RECIPIENT: "E-postmottagare (f\xF6rnamn och efternamn)",
  MAILING_RECIPIENT_REQUIRED: "Beg\xE4rd postmottagare",
  MAINTENANCE: "Underh\xE5ll",
  MAINTENANCE_PLAN: "Underh\xE5llsplaner",
  MAINTENANCE_PLAN_INFO: "Information om underh\xE5llsplan",
  MARK_AS_REVIEW: "Markera som granskad",
  MARKETING_INCENTIVE: "Marknadsf\xF6ring - Incitament",
  MARKETING_JD_PROMISE: "Marknadsf\xF6ring - JD Promise",
  MARKETING_MAINTENANCE_PLAN: "Marknadsf\xF6ring - Underh\xE5llsplan",
  MARKETING_MASS_CHANNEL_FOLLOWUP: "Marknadsf\xF6ring - Masskanaluppf\xF6ljning",
  MARKETING_MASS_CHANNEL_PDI: "Marknadsf\xF6ring - Massa-kanal PDI",
  MASS_CHANNEL_CUSTOMER_FOLLOW_UP: "Uppf\xF6ljning av masskanal",
  MASS_CHANNEL_CUSTOMER_FOLLOW_UP_HELP_TEXT: "P\xE5minn dig om att kontakta din egen juridiska r\xE5dgivare f\xF6r att fastst\xE4lla l\xE4mpliga #Do Not Call#-procedurer inom din stat och p\xE5 federal niv\xE5 innan du genomf\xF6r din uppf\xF6ljning efter f\xF6rs\xE4ljningssamtalsprogrammet",
  MASS_CHANNEL_PDI_CLAIM: "Masskanal PDI",
  MASTER_WARRANTY_TYPE: "Huvudgarantityp",
  MATERIAL: "Materialnummer",
  MERCHANDISE: "Merchandise",
  MESSAGE: "Meddelande",
  MESSAGES: "Meddelanden",
  METHOD_OF_CONTACT: "Kontaktmetod",
  METHOD_OF_CONTACT_IS_REQUIRED: "Kontaktmetod kr\xE4vs",
  METRIC: "Metrisk",
  METRICS: "M\xE4tningar",
  MILEAGE_LIMIT: "Medelgr\xE4ns",
  MOBILE_PHONE: "Mobiltelefon",
  MODEL: "Modell",
  MODEL_NUMBER: "Modellnummer",
  MODIFIED: "Modifierad",
  MONTH_TO_DATE: "M\xE5nad till datum",
  MORE: "Mer",
  MULTIPLE: "Flera",
  NAME: "Namn",
  NET: "N\xE4t",
  NET_AMOUNT: "Nettobelopp",
  NET_AMOUNT_PAID: "Betalat nettobelopp",
  NET_TOTAL: "Totalt n\xE4t",
  NEW: "Ny",
  NEW_ACCOUNT: "Nytt konto",
  NEW_CLAIM: "Nytt anspr\xE5k",
  NEW_CLAIM_VALUE: "Nytt anspr\xE5ksv\xE4rde",
  NEW_CUSTOMER_REQUIRED: "Ny kund kr\xE4vs",
  NEW_DEALER: "Ny \xE5terf\xF6rs\xE4ljare",
  NEW_DEALER_DISTANCE: "Nytt \xE5terf\xF6rs\xE4ljaravst\xE5nd",
  NEW_DEALER_LOCATION: "Ny \xE5terf\xF6rs\xE4ljarplats",
  NEW_LABOR_RATE: "Ny arbetshastighet",
  NEW_REQUEST_ENTER_RATES: "Ny beg\xE4ran - Ange doseringar",
  NEW_STATUS: "Ny status",
  NEW_TRANSFER: "Ny \xF6verf\xF6ring",
  NEW_TRANSFER_CREATED: "Ny \xF6verf\xF6ring skapad",
  NEW_VALUE: "Nytt v\xE4rde",
  NO: "NEJ",
  NO_ACTIVE_WARRANTY: "Ingen aktiv garanti",
  NO_AFFECTED_PINS: "Det finns inga PIN-koder som ber\xF6rs av ditt \xE5terf\xF6rs\xE4ljaransvar",
  NO_AUTHORITY_TO_ACCESS: "Du har inte beh\xF6righet att komma \xE5t JDWS. \xC5terf\xF6rs\xE4ljaranv\xE4ndare ska f\xF6lja upp med din profiladministrat\xF6r (DPA) f\xF6r att verifiera myndighet och Deere-anv\xE4ndare kontaktar Support med en kopia av detta fel",
  NO_CLAIMS: "Det finns inga krav.",
  NO_CUSTOMER_ASSOCIATED: "Ingen kund associerad",
  NO_CUSTOMER_SELECTED: "Ingen kund vald",
  NO_DEALER_INVOICES: "Inga \xE5terf\xF6rs\xE4ljarfakturor",
  NO_DEALERS_MAPPED: "Inga \xE5terf\xF6rs\xE4ljare har tilldelats ditt anv\xE4ndar-ID. Kontakta systemadministrat\xF6ren.",
  NO_IF_NO_A_PICTURE_MUST_BE_PROVIDED_AS_EVIDENCE: "Nej (om nej, en bild m\xE5ste visas som bevis)",
  NO_INFORMATION_AVAILABLE_FOR_THIS_PRODUCT: "Ingen information tillg\xE4nglig f\xF6r denna produkt",
  NO_LOWERCASE: "Nej",
  NO_MATCHING_DEALERS: "Inga \xE5terf\xF6rs\xE4ljare matchar filtertexten.",
  NO_OPEN_PART_REQUESTS: "Inga \xF6ppna reservdelsf\xF6rfr\xE5gningar",
  NO_OPEN_PIPS: "Inga \xF6ppna PIP:er",
  NO_PARTS_RETURNED: "Inga reservdelar returnerade",
  NO_PIP_PRODUCTS: "Det finns inga PIP-produkter.",
  NO_PRODUCT_FOUND: "Ingen produkt hittades",
  NO_REQUIRED_ITEMS: "Det finns inga obligatoriska objekt.",
  NO_RESULTS: "Inga resultat",
  NO_RESULTS_FOUND: "Inga resultat hittades",
  NO_ROWS_TO_SHOW: "Inga rader att visa",
  NO_SPECIAL_INSTRUCTIONS: "Det finns inga s\xE4rskilda instruktioner.",
  NO_TRAVEL: "Ingen resa",
  NON_RECOVERABLE_TAXES: "Icke \xE5tervinningsbara skatter",
  NON_TRACKED_PINS_HELP_TEXT: "Vissa produkter visas inte i Garantin f\xF6rr\xE4n efter registreringen. Din s\xF6kning matchar en rad av dessa produkter.",
  NON_TRAVEL: "Icke-k\xF6rning",
  NONE: "Ingen",
  NORMAL: "NORMAL",
  NOT_EQUAL: "Inte lika med",
  NOTIFICATION_ADDED_SUCCESSFULLY: "Meddelande har lagts till",
  NOTIFICATION_DELETED_SUCCESSFULLY: "Meddelandet raderades",
  NOTIFICATION_SEQUENCE_UPDATED_SUCCESSFULLY: "Meddelandesekvensen har uppdaterats",
  NOTIFICATION_UPDATED_SUCCESSFULLY: "Meddelande uppdaterat",
  NOTIFICATIONS: "Meddelanden",
  NUMBER_OF_DIAGNOSTICS_OCCURRENCES: "Antal fels\xF6kningar",
  NUMBER_OF_OPEN_PIPS: "{number} Open PIPs",
  NUMBER_OF_REPAIR_OCCURRENCES: "Antal reparationer",
  NUMBER_OF_REPLACEMENT_OCCURRENCES: "Antal utbytestillf\xE4llen",
  OLD_LABOR_RATE: "Gammal arbetshastighet",
  ON_SHELF: "P\xE5 hyllan",
  ON_SHELF_COST: "Kostnad f\xF6r inkapsling",
  ONE_ITEM_MUST_BE_SELECTED: "En post m\xE5ste v\xE4ljas",
  OPEN: "\xD6ppna",
  OPEN_PART_REQUESTS: "Beg\xE4ran om \xF6ppen reservdel",
  OPEN_PART_REQUESTS_WITH_COUNT: "Beg\xE4ran om \xF6ppen del ({count})",
  OPEN_PIP_COUNT: "\xD6ppna PIP-antal",
  OPEN_PIP_PROGRAMS: "PIP-register",
  OPEN_PIPS: "\xD6ppna PIP:er",
  OPEN_PIPS_REPORT: "\xD6ppna PIP-rapport",
  OPEN_PIPS_TAB: "\xD6ppna PIP:er ({count})",
  OPERATORS_COMPLAINT: "Vad klagade f\xF6raren p\xE5?",
  OPERATORS_COMPLAINT_IS_REQUIRED: "F\xF6rarens klagom\xE5l kr\xE4vs",
  OPERATORS_MANUAL_NUMBER: "Instruktionsboksnummer",
  OPTION_CODE: "Tillvalskod",
  OPTION_CODE_CREATED_SUCCESSFULLY: "Tillvalskoden har skapats",
  OPTION_CODE_DELETED_SUCCESSFULLY: "Tillvalskoden raderades",
  OPTION_CODES: "Tillvalskoder",
  OR: "eller",
  ORIGINAL_CLAIM_VALUE: "Ursprungligt anspr\xE5ksv\xE4rde",
  ORIGINAL_SUBMISSION_DATE: "Ursprungligt inl\xE4mningsdatum",
  ORIGINALLY_SUBMITTED: "Ursprungligen inl\xE4mnad",
  OTHER: "\xD6vrigt",
  OTHER_AMOUNT_OF_USE: "Annan anv\xE4ndning",
  OTHER_AMOUNT_OF_USE_REQUIRED: "Annan anv\xE4ndning som kr\xE4vs",
  OTHER_CREDIT: "Annan kredit",
  OTHER_CREDIT_1: "Annan kredit 1",
  OTHER_CREDIT_2: "Annan kredit 2",
  OTHER_CREDIT_3: "Annan kredit 3",
  OTHER_CREDIT_ADJUSTMENT: "Annan kreditjustering",
  OTHER_CREDIT_ITEM_DETAILS: "Annan kredit - {beskrivning} ({quantity} {unit})",
  OTHER_CREDIT_TOTAL: "\xD6vrig kreditsumma",
  OTHER_CREDITS: "\xD6vriga krediter",
  OTHER_CREDITS_WITH_COUNT: "\xD6vriga krediter ({count})",
  OTHER_INSTRUCTIONS: "\xD6vriga anvisningar",
  OUTPUT_PIN: "Utg\xE5ende PIN",
  OVERDUE: "F\xF6rfallen",
  OVERRIDE_ACCOUNT: "Skriv \xF6ver konto",
  OVERRIDE_EFFECTIVE_DATE: "Upph\xE4vning av giltighetsdatum",
  OVERRIDE_SUGGESTED_ACCOUNT: "Skriv \xF6ver f\xF6reslaget konto",
  OWNERSHIP_STATUS: "\xC4garstatus",
  OWNERSHIP_STATUS_IS_REQUIRED: "\xC4garstatus kr\xE4vs",
  PART: "Del",
  PART_1: "Del 1",
  PART_2: "Del 2",
  PART_3: "Del 3",
  PART_4: "Del 4",
  PART_5: "Del 5",
  PART_6: "Del 6",
  PART_7: "Del 7",
  PART_8: "Del 8",
  PART_9: "Del 9",
  PART_10: "Del 10",
  PART_AMONT_OF_USE: "Reservdelsanv\xE4ndning",
  PART_FAMILY: "Reservdelsfamilj",
  PART_ITEM_DETAILS: "Reservdelar - {quantity} {beskrivning} (Part # {partNumber})",
  PART_NUMBER: "Artikelnummer",
  PART_REQUEST: "Reservdelsbeg\xE4ran",
  PART_REQUEST_NUMBER: "Reservdelsbeg\xE4ran {rgaNumber}",
  PART_REQUEST_STATUS: "Status f\xF6r reservdelsbeg\xE4ran",
  PART_REQUESTS: "Reservdelsbeg\xE4ran",
  PART_REQUESTS_SEARCH_BY_CLAIM_PLACEHOLDER: "Ange anspr\xE5ksnummer, minst 4 tecken",
  PART_REQUESTS_SEARCH_BY_CLAIM_VALIDATION_ERROR: "S\xF6kningen av anspr\xE5k m\xE5ste vara minst 4 tecken",
  PART_REQUESTS_SEARCH_BY_DTAC_CASE_NUMBER_ERROR: "S\xF6kning efter DTAC-\xE4rendenummer m\xE5ste vara ett fullst\xE4ndigt DTAC-\xE4rendenummer med minst 4 tecken",
  PART_REQUESTS_SEARCH_BY_DTAC_CASE_NUMBER_PLACEHOLDER: "Ange ett fullst\xE4ndigt DTAC-\xE4rendenummer",
  PART_REQUESTS_SEARCH_BY_PART_NUMBER_ERROR: "S\xF6kning efter artikelnummer m\xE5ste vara minst 4 tecken",
  PART_REQUESTS_SEARCH_BY_PART_NUMBER_PLACEHOLDER: "Ange artikelnummer, minst 4 tecken",
  PART_REQUESTS_SEARCH_BY_PART_REQUEST_ERROR: "S\xF6kning efter artikelnummer m\xE5ste vara minst 4 tecken",
  PART_REQUESTS_SEARCH_BY_PART_REQUEST_PLACEHOLDER: "Ange reservdelsbeg\xE4ran, minst 4 tecken",
  PART_REQUESTS_SEARCH_BY_PIN_ERROR: "PIN-s\xF6kningen m\xE5ste vara minst 4 tecken",
  PART_REQUESTS_SEARCH_BY_PIN_PLACEHOLDER: "Ange PIN-kod, minst 4 tecken",
  PART_REQUESTS_SEARCH_BY_WORK_ORDER_ERROR: "S\xF6kning efter arbetsorder m\xE5ste vara full jobborder, minst 2 tecken",
  PART_REQUESTS_SEARCH_BY_WORK_ORDER_PLACEHOLDER: "Ange full arbetsorder",
  PART_REQUESTS_UPDATED_SUCCESSFULLY: "Reservdelsbeg\xE4ran har uppdaterats",
  PART_RETURN: "Reservdelsretur",
  PART_RETURNS: "Reservdelsretur",
  PART_SERIAL_NUMBER: "Reservdelens serienummer",
  PART_SERIAL_NUMBER_IS_REQUIRED: "Reservdelens serienummer kr\xE4vs",
  PART_TOTAL: "Reservdelstotal",
  PART_TYPE: "Reservdelstyp",
  PART_USE: "Anv\xE4ndning av reservdelar",
  PART_VALUE: "Reservdelsv\xE4rde",
  PARTIAL_DEBIT: "Delvis debit",
  PARTICIPANT: "Deltagare",
  PARTS: "Reservdelar",
  PARTS_ADDITIVE: "Reservdelstillsats",
  PARTS_ADJUSTMENT: "Justering av delar",
  PARTS_COVERAGE_SEARCH: "S\xF6kning av reservdelst\xE4ckning",
  PARTS_TEMPLATE: "Mall f\xF6r reservdelar",
  PARTS_USE: "Anv\xE4ndning av reservdelar",
  PARTS_USE_IS_REQUIRED: "Reservdelsanv\xE4ndning kr\xE4vs",
  PARTS_WITH_COUNT: "Reservdelar ({count})",
  PARTS_WITH_PARENTHESES: "Del(ar)",
  PAST_DUE: "F\xF6rfallna",
  PAYER_ACCOUNT: "Betalarkonto",
  PERCENT_COMPLETE: "Procent slutf\xF6rt",
  PERCENTAGE: "Procent",
  PERCENTAGE_DEBIT: "Procentuell deplacement",
  PERCENTAGE_SYMBOL: "{procent}%",
  PERCENTAGE_TO_DEBIT: "Procent till deplacement",
  PERMANENTLY_OUT_OF_SERVICE_MACHINES: "Maskiner som inte beh\xF6ver service permanent",
  PERMANENTLY_OUT_OF_SERVICE_MACHINES_HELP_TEXT: "F\xF6r maskiner som inte \xE4r i drift ska du inkludera en bild av maskinen f\xF6r att verifiera att maskinen inte kan renoveras, repareras eller anv\xE4ndas n\xE5gon g\xE5ng i framtiden. Maskiner som inte \xE4r i drift uppfyller inte villkoren f\xF6r PIP av n\xE5got slag.",
  PERSON_RESPONSIBLE: "Ansvarig person",
  PHONE: "Telefon",
  PHONE_REQUIRED: "Telefon kr\xE4vs",
  PICTURE: "Bild",
  PICTURE_REQUEST: "Bildbeg\xE4ran",
  PICTURE_REQUEST_STATUS: "Status f\xF6r bildbeg\xE4ran",
  PICTURE_REQUEST_STATUS_ERROR: "Tillbeh\xF6r kan skickas med denna beg\xE4ran.",
  PIN: "PIN",
  PIN_CREATED_SUCCESSFULLY: "PIN-kod har skapats",
  PIN_CROSS_REFERENCE: "PIN-korsh\xE4nvisning",
  PIN_INVALID: "PIN ogiltig",
  PIN_IS_REQUIRED: "Stift kr\xE4vs",
  PIN_REQUIRED: "PIN kr\xE4vs",
  PIN_SEARCH: "PIN-s\xF6kning",
  PIN_SEARCH_INFORMATION: "PIN-s\xF6kinformation",
  PIN_TRANSFER_INFORMATION: "Information om \xF6verf\xF6ring av stift",
  PINS: "PIN",
  PINS_NOT_REGISTERED: "PIN-koder ej registrerade",
  PIP: "PIP",
  PIP_CODE: "PIP-kod",
  PIP_CODE_CREATED_SUCCESSFULLY: "PIP-kodbeg\xE4ran har skapats",
  PIP_CODE_REQUEST: "Beg\xE4ran om PIP-kod",
  PIP_CODE_REQUEST_APPROVED: "PIP-kodsbeg\xE4ran godk\xE4nd",
  PIP_CODE_REQUEST_REJECTED: "PIP-kodsbeg\xE4ran avvisades",
  PIP_CODE_REQUESTS_WITH_COUNT: "PIP-kodf\xF6rfr\xE5gningar ({count})",
  PIP_COMPLETION_STATUS: "PIP-slutf\xF6randestatus",
  PIP_DETAILS: "PIP-detaljer",
  PIP_HISTORY: "PIP-historik",
  PIP_ID: "PIP-nr",
  PIP_NUMBER: "PIP-nummer",
  PIP_PROGRAM: "PIP-program",
  PIP_PROGRAM_IS_REQUIRED: "PIP-program kr\xE4vs",
  PIP_PROGRAMS: "PIP-program",
  PIP_SEARCH: "PIP-s\xF6kning",
  PIP_STATUS: "PIP-status",
  PIP_TYPE: "PIP-typ",
  PIP_TYPES: "PIP-typer",
  PIPS: "PIP:er",
  PIPS_UNPAID_LABOR_ADDITIVE: "PIP:s Obetalda till\xE4gg av arbete",
  PLAN_DESCRIPTION: "Planbeskrivning",
  PLAN_END_DATE: "Planera slutdatum",
  PLAN_ENDS: "Planera slut",
  PLAN_NAME: "Plannamn",
  PLAN_NAME_IS_REQUIRED: "Plannamn kr\xE4vs",
  PLAN_NAMES: "Plannamn",
  PLAN_START_DATE: "Planstartdatum",
  PLAN_STARTS: "Planera start",
  PLANNED_BY: "Planerad av",
  PLANT: "Anl\xE4ggning",
  PLATE_REQUEST_INFORMATION: "Information om pl\xE5tbeg\xE4ran",
  PLEASE_SELECT_A_LEAD_ACCOUNT: "V\xE4lj ett huvudkonto",
  PLEASE_SELECT_CLAIM_TYPE: "V\xE4lj anspr\xE5kstyp",
  POLISH: "polsk",
  PORTUGUESE: "Portugisiska",
  POSTAGE_DELIVERY_DATE: "Leveransdatum efter leverans",
  POSTAL_CODE: "Postnummer",
  POSTAL_CODE_REQUIRED: "Postnummer kr\xE4vs",
  POSTAL_TRACKING_NUMBER: "Postsp\xE5rnummer",
  POTENTIAL_RESPONSIBLE_DEALER: "Potentiell ansvarig \xE5terf\xF6rs\xE4ljare",
  PRE_DELIVERY_INSPECTION: "Inspektion f\xF6re leverans",
  PREFERRED_THEME: "F\xF6redraget tema",
  PREPARE_AUDIT: "F\xF6rbered granskning",
  PREPARED: "F\xF6rberedd",
  PREPARING_AUDIT_FOR_WITH_DEALER: "F\xF6rberedelse av granskning f\xF6r {dealer}",
  PREVIOUS_AMOUNT_OF_USE: "Tidigare anv\xE4ndningsm\xE4ngd",
  PREVIOUS_INVOICE_NUMBER: "F\xF6reg\xE5ende fakturanummer",
  PREVIOUS_INVOICE_NUMBER_IS_REQUIRED: "Tidigare fakturanummer kr\xE4vs",
  PREVIOUS_MONTH: "F\xF6reg\xE5ende m\xE5nad",
  PRICE: "Pris",
  PRICING_SUMMARY: "Prissammanfattning",
  PRIMARY_ACTION: "Prim\xE4r \xE5tg\xE4rd",
  PRIMARY_LANGUAGE: "Prim\xE4rt spr\xE5k",
  PRINT: "Skriv ut",
  PRINT_CLAIM: "Skriv ut anspr\xE5k",
  PRINT_REGISTRATION_FORM: "Skriv ut registreringsformul\xE4r",
  PRINT_REGISTRATION_FORM_MESSAGE: "Produkt registrerad hos f\xF6rsta \xE4garen. Vill du skriva ut registreringsformul\xE4ret nu?",
  PRINT_TO_PDF: "Skriv ut till PDF",
  PRIORITY: "Prioritet",
  PRNT_CLM: "Displayanspr\xE5k",
  PROCESS_DATE: "Processdatum",
  PROCESSED: "Bearbetat",
  PROCESSED_PART_REQUESTS: "Beg\xE4randen f\xF6r bearbetade delar",
  PROCESSING_STATUS: "Bearbetningsstatus",
  PROCESSING_STATUS_DESCRIPTION: "Beskrivning av bearbetningsstatus",
  PRODUCT_DETAILS: "Produktdetaljer",
  PRODUCT_HIERARCHY: "Produkthierarki",
  PRODUCT_INFORMATION: "Produktinformation",
  PRODUCT_REGISTERED: "Produkt registrerad",
  PRODUCT_REGISTRATION: "Produktregistrering",
  PRODUCT_REGISTRATION_PENDED: "Produktregistrering \xE4r v\xE4ntad",
  PRODUCT_TRACKING: "Produktsp\xE5rning",
  PRODUCTS: "Produkter",
  PRODUCTS_BY_CUSTOMER: "Produkter efter kund",
  PRODUCTS_BY_CUSTOMER_PARTIAL_DATA_WARNING: "Historiska PIN-nummer kan saknas i s\xF6kresultaten p\xE5 grund av ett tillf\xE4lligt anslutningsproblem med systemet",
  PRODUCTS_WITH_COUNT: "Produkter ({count})",
  PROGRAM: "Program",
  PROGRAM_DESCRIPTION: "Programbeskrivning",
  PROGRAM_IS_REQUIRED: "Program kr\xE4vs.",
  PROGRAM_NAME: "Programnamn",
  PROGRAM_NUMBER: "Programnummer",
  PRT: "PRT",
  PRTS: "PRT",
  PURCHASE_INFO: "Ink\xF6psinformation",
  PURCHASE_ORDER: "Ink\xF6psorder",
  PURCHASE_ORDER_IS_REQUIRED: "Ink\xF6psorder kr\xE4vs",
  PURCHASER_TYPE: "K\xF6partyp",
  PURCHASER_TYPE_REQUIRED: "K\xF6partyp kr\xE4vs",
  PUSH_XML: "\xC5terst\xE4ll XML",
  QTY: "Antal",
  QUALIFY_FOR_EMISSIONS: "Kvalificera f\xF6r utsl\xE4pp",
  QUANTITY: "Kvantitet",
  QUANTITY_1: "Kvantitet 1",
  QUANTITY_2: "Kvantitet 2",
  QUANTITY_3: "Kvantitet 3",
  QUANTITY_4: "Kvantitet 4",
  QUANTITY_5: "Kvantitet 5",
  QUANTITY_6: "Kvantitet 6",
  QUANTITY_7: "Kvantitet 7",
  QUANTITY_8: "Kvantitet 8",
  QUANTITY_9: "Kvantitet 9",
  QUANTITY_10: "Kvantitet 10",
  QUERY_MUST_CONTAIN_3_CHARACTERS: "Fr\xE5ga m\xE5ste inneh\xE5lla minst 3 tecken",
  QUEST_DESC: "Fr\xE5gest\xE4llbar beskrivning",
  QUESTIONABLE_PART: "Fr\xE5gest\xE4llbar del",
  QUEUED: "K\xF6rad",
  REASON_FOR_CHANGE: "Orsak till \xE4ndring",
  REASON_FOR_DEBIT: "Orsak till indragning",
  REASON_FOR_MISSING_PLATE: "Orsak till att pl\xE5t saknas",
  REASON_FOR_MISSING_PLATE_REQUIRED: "Orsak till att pl\xE5t saknas kr\xE4vs",
  REASON_FOR_OVERRIDE: "Orsak till f\xF6rbikoppling",
  REASON_FOR_REFUSAL: "Sk\xE4l till avslag",
  REASON_FOR_RETURN: "Orsak till retur",
  REASON_FOR_RETURN_IS_REQUIRED: "Orsak till retur kr\xE4vs",
  REASON_FOR_TRANSFER: "Orsak till \xF6verf\xF6ring",
  REASON_FOR_TRANSFER_MUST_CONTAIN_ALPHANUMERIC_CHARACTERS: "Anledningen till \xF6verf\xF6ringen m\xE5ste inneh\xE5lla alfanumeriska tecken",
  RECIPIENT_DEALER_OR_TCSM: "Mottagare (\xE5terf\xF6rs\xE4ljare eller TCSM)",
  RECIPIENT_MAILING: "E-postmottagare",
  RECONCILE: "f\xF6renlig",
  RECONCILE_CLAIM: "\xD6verensst\xE4mmelseanspr\xE5k",
  RECONCILED: "Till\xE5ten",
  RECORD_AUDIT: "Registrera granskning",
  RECORD_AUDIT_FOR: "Registrera granskning f\xF6r {dealer}",
  RECORDS_FOUND: "{countToDisplay} {count, plural, one {record} other {record} found}",
  RECOVERABLE_TAXES: "\xC5terbetalningsbara skatter",
  RECOVERED: "\xC5tervunnen",
  RECOVERED_WITH_MISSED_ADDITIVES: "\xC5tervinning med saknade tillsatser",
  RECOVERED_WITHOUT_ADDITIVES: "\xC5tervinning utan tillsatser",
  RECOVERY: "\xC5terh\xE4mtning",
  RED_MUST_BE_LESS_THAN_YELLOW: "Det r\xF6da indikatorv\xE4rdet m\xE5ste vara l\xE4gre \xE4n det gula indikatorv\xE4rdet",
  REFERENCE_1: "Referens 1",
  REFERENCE_2: "Referens 2",
  REFERENCE_INFORMATION: "Referensinformation",
  REFERENCE_NUMBER1: "Referensnummer 1",
  REFERENCE_NUMBER2: "Referensnummer 2",
  REGION: "Region",
  REGISTER: "Registrera",
  REGISTER_A_PRODUCT_BY_PIN: "Registrera en produkt efter PIN-kod",
  REGISTER_A_PRODUCT_TO_ADD: "Registrera produkten som ska l\xE4ggas till i garantisystemet",
  REGISTER_ANOTHER_PRODUCT: "Registrera en annan produkt",
  REGISTER_PRODUCT: "Registrera produkt",
  REGISTER_PRODUCT_AND_REGISTER_ANOTHER: "Registrera produkten och registrera en annan",
  REGISTERED: "Registrerad",
  REGISTRATION: "Registrering",
  REGISTRATION_DATE: "Registreringsdatum",
  REGISTRATION_DATES: "Registreringsdatum",
  REGISTRATION_FORM: "Registreringsformul\xE4r",
  REGISTRATION_HISTORY: "Registreringshistorik",
  REGISTRATION_NOT_ALLOWED: "Registrering ej till\xE5ten f\xF6r denna produkt",
  REGISTRATION_REVIEW: "Registreringsgranskning",
  REGISTRATION_REVIEW_TAB: "Registreringsgranskning ({count})",
  REGISTRATION_STATUS: "Registreringsstatus",
  REGISTRATION_STATUS_CANNOT_BE_NEW: "Registreringsstatus kan inte vara Ny",
  REGISTRATION_STATUS_REQUIRED: "Registreringsstatus kr\xE4vs",
  REGISTRATION_SUCCESS: "Registreringen lyckades",
  REGISTRATION_TYPE: "Registreringstyp",
  REGISTRATION_TYPE_CANNOT_BE_NEW: "Registreringstyp kan inte vara ny",
  REGISTRATION_TYPE_REQUIRED: "Registreringstyp kr\xE4vs",
  REGISTRATION_UPDATED_SUCCESSFULLY: "Registreringen har uppdaterats",
  REGISTRATIONS_REVIEW: "Granskning av registreringar",
  REIMBURSED: "Ersatt",
  REIMBURSED_AMOUNT: "Ersatt belopp",
  REIMBURSED_PERCENTAGE: "\xC5terbetald procentandel",
  REIMBURSED_PERCENTAGE_INDICATOR: "Indikator f\xF6r \xE5terbetald procentandel",
  REIMBURSEMENT_DETAILS: "\xC5terbetalningsdetaljer",
  REIMBURSEMENT_PERCENTAGE: "\xC5terbetalningsprocent",
  REIMBURSEMENT_SUMMARY: "\xC5terbetalningssammanfattning",
  REJECT: "Avvisa",
  REJECT_LABOR_RATE: "Avvisa arbetshastighet",
  REJECT_SPECIAL_ALLOWANCE_CLAIM: "Avvisa beg\xE4ran om s\xE4rskild ers\xE4ttning",
  REJECTED: "Avslagen",
  REJECTED_APPEAL: "Avvisad \xF6verklagan",
  RELATIONSHIP: "Relation",
  RELATIONSHIP_IS_REQUIRED: "F\xF6rh\xE5llande kr\xE4vs",
  REMOVE_FILTER: "Ta bort filtret",
  REMOVE_FROM_AUDIT: "Ta bort fr\xE5n granskning",
  REMOVE_LAYOUT: "Ta bort layout",
  RENTAL_PINS: "PIN-kod f\xF6r uthyrning",
  REPAIR_DATE: "Reparationsdatum",
  REPAIR_DATE_CANNOT_BE_BEFORE_FAILURE_DATE: "Reparationsdatumet kan inte infalla f\xF6re feldatumet",
  REPAIR_NUMBER: "Reparationsnummer",
  REPAIR_NUMBER_IS_REQUIRED: "Reparationsnummer kr\xE4vs",
  REPAIR_REPLACE_INDICATOR: "Indikator f\xF6r reparation/utbyte",
  REPAIRED: "Reparerad",
  REPAIRED_DATE: "Reparationsdatum",
  REPAIRED_DATE_CANNOT_BE_BEFORE_FAILED_DATE: "Det reparerade datumet kan inte vara f\xF6re det misslyckade datumet",
  REPAIRED_DATE_IS_REQUIRED: "Reparationsdatum kr\xE4vs",
  REPORT_DATE: "Rapportdatum",
  REPORT_NUMBER: "Rapportnummer",
  REPORTS: "Rapporter",
  REQ_ADDL: "Justera kredit",
  REQUEST_DATE: "Beg\xE4randedatum",
  REQUEST_DETAILS: "Beg\xE4r detaljer",
  REQUEST_DUPLICATE_PIN_PLATE: "Beg\xE4r dubbel PIN-skylt",
  REQUEST_FORM: "Beg\xE4ran om formul\xE4r",
  REQUEST_PIP_CODE: "Beg\xE4r PIP-kod",
  REQUEST_STATUS: "Beg\xE4r status",
  REQUEST_SUBMITTED: "Beg\xE4ran skickad",
  REQUEST_TYPE: "Typ av beg\xE4ran",
  REQUEST_UPDATED_SUCCESSFULLY: "Beg\xE4ran har uppdaterats",
  REQUEST_WARRANTY_CLAIM_DEBIT: "Beg\xE4r garantianspr\xE5ksavveckling",
  REQUESTED: "Beg\xE4rd",
  REQUESTED_BY: "Beg\xE4rd av",
  REQUESTED_DATE: "Beg\xE4rt datum",
  REQUESTED_DATES: "Beg\xE4rda datum",
  REQUESTED_DIAGNOSTIC_AMOUNT: "Beg\xE4rt fels\xF6kningsbelopp",
  REQUESTED_DIAGNOSTIC_HOURS: "Beg\xE4rda diagnostimmar",
  REQUESTED_LABOR_AMOUNT: "Beg\xE4rt arbetsbelopp",
  REQUESTED_LABOR_HOURS: "Beg\xE4rda arbetstimmar",
  REQUESTED_OTHER_CREDITS: "Beg\xE4rda andra krediter",
  REQUESTED_PARTS: "Beg\xE4rda delar",
  REQUESTED_REPAIR_AMOUNT: "Beg\xE4rd reparationsm\xE4ngd",
  REQUESTED_REPAIR_HOURS: "Beg\xE4rda reparationstimmar",
  REQUESTED_TRAVEL_TOTAL: "Beg\xE4rd total k\xF6rning",
  REQUESTER_TCSM: "Beg\xE4rare (TCSM)",
  REQUESTER_TCSM_REQUIRED: "Beg\xE4rd(TCSM) kr\xE4vs",
  REQUIRED: "n\xF6dv\xE4ndig",
  REQUIRED_CRITERIA: "N\xF6dv\xE4ndiga kriterier",
  REQUIRED_ITEMS: "N\xF6dv\xE4ndiga funktioner",
  RESEND_XML: "\xC5terst\xE4ll XML",
  RESET: "\xC5terst\xE4ll",
  RESPONDENT_INFORMATION: "Svarsinformation",
  RESPONSIBILITY_OF: "Ansvar f\xF6r",
  RESPONSIBLE_ACCOUNT: "Ansvarigt konto",
  RESPONSIBLE_ACCOUNT_IS_REQUIRED: "Ett ansvarsfullt konto kr\xE4vs",
  RESPONSIBLE_DEALER: "Ansvarig \xE5terf\xF6rs\xE4ljare",
  RET: "Retur",
  RETAIL_INSTALL: "Hush\xE5ll/installation",
  RETAIL_INSTALL_DATE: "\xC5terf\xF6rs\xE4ljnings-/installationsdatum",
  RETAIL_INSTALL_IS_REQUIRED: "Kr\xE4ver butik/installation",
  RETAILER_NAME: "\xC5terf\xF6rs\xE4ljarens namn",
  RETAILER_NAME_IS_REQUIRED: "\xC5terf\xF6rs\xE4ljarens namn kr\xE4vs",
  RETRY: "\xE5terf\xF6rs\xF6k",
  RETURN: "Retur",
  RETURN_LABOR_RATE: "Returarbetshastighet",
  RETURN_REQUEST: "Returbeg\xE4ran",
  RETURN_SPECIAL_ALLOWANCE_CLAIM: "S\xE4rskilda \xE5terv\xE4ndandeanspr\xE5k",
  RETURN_STATUS: "Returstatus",
  RETURNED: "Returnerad",
  RETURNED_DATE_CANNOT_BE_BEFORE_DELIVERED_DATE: "Returdatum kan inte l\xE4mnas f\xF6re leveransdatum",
  RETURNED_DATE_IS_REQUIRED: "Returdatum kr\xE4vs",
  REVIEW_DEALER_RECOMMENDATIONS: "Vill du markera stiftet f\xF6r Granska?",
  REVISE: "\xD6versyn",
  REVISED: "\xC4ndrad",
  ROLLING_12_CREDIT_AMOUNT: "Rullande 12 kreditbelopp",
  ROLLING_12_MONTHS: "Rullande 12 m\xE5nader",
  RUN_REPORT: "K\xF6r rapport",
  RUSSIAN: "ryska",
  SAP_DOWN_WARNING: "Garantisystemets funktion \xE4r nedsatt. Vi arbetar f\xF6r att r\xE4tta till detta s\xE5 snabbt som m\xF6jligt. Uppdatera webbl\xE4saren f\xF6r att kontrollera systemets tillg\xE4nglighet.",
  SAVE: "Spara",
  SAVE_AS_DRAFT: "Spara som utkast",
  SAVE_AS_NEW_LAYOUT: "Spara som ny layout",
  SAVE_AUDIT: "Spara granskning",
  SAVE_CHANGES: "Spara \xE4ndringar",
  SAVE_TO_VALIDATE: "Spara f\xF6r att validera",
  SAVE_VALD: "Spara och validera",
  SAVE_VALIDATE: "Spara och validera",
  SEARCH: "S\xF6k",
  SEARCH_BOX_PLACEHOLDER: "Ange PIN-kod, serienummer, anspr\xE5ksnummer, DTAC-\xE4rende eller kundnamn",
  SEARCH_BY_CLAIM_TYPE: "Ange full anspr\xE5kstyp",
  SEARCH_BY_CLAIM_TYPE_VALIDATION_FAIL: "S\xF6kningen av anspr\xE5k m\xE5ste ske efter typ av anspr\xE5k, fr\xE5n 4 till 9 tecken",
  SEARCH_BY_FAILURE_PART_NUMBER: "Ange reservdelsnummer f\xF6r fullt fel",
  SEARCH_BY_FAILURE_PART_NUMBER_VALIDATION_FAIL: "S\xF6kningen efter anspr\xE5k m\xE5ste ske genom artikelnumret f\xF6r hela felet, minst 4 tecken",
  SEARCH_BY_WORK_ORDER: "Ange arbetsorder, minst 2 tecken",
  SEARCH_BY_WORK_ORDER_VALIDATION_FAIL: "S\xF6kning efter arbetsorder m\xE5ste inneh\xE5lla minst 2 tecken",
  SEARCH_PRODUCT_BY_CLAIM_PLACEHOLDER: "Ange det fullst\xE4ndiga anspr\xE5ksnumret",
  SEARCH_PRODUCT_BY_CLAIM_VALIDATION_FAIL: "S\xF6kningen efter anspr\xE5k m\xE5ste ske med ett fullst\xE4ndigt anspr\xE5ksnummer, mellan 4 och 9 tecken",
  SEARCH_PRODUCT_BY_COMPONENT_PLACEHOLDER: "Ange hela komponentens serienummer",
  SEARCH_PRODUCT_BY_COMPONENT_VALIDATION_FAIL: "Komponents\xF6kningen m\xE5ste ske med fullt serienummer, minst 1 tecken",
  SEARCH_PRODUCT_BY_FULL_PIN_PLACEHOLDER: "Ange PIN-kod",
  SEARCH_PRODUCT_BY_MODEL_PLACEHOLDER: "Ange fullst\xE4ndigt modellnummer",
  SEARCH_PRODUCT_BY_MODEL_VALIDATION_FAIL: "Modells\xF6kningen m\xE5ste vara ett fullst\xE4ndigt modellnummer, fr\xE5n 3 till 12 tecken",
  SEARCH_PRODUCT_BY_PIN_PLACEHOLDER: "Ange PIN-kod, minst 6 tecken",
  SEARCH_PRODUCT_BY_PIN_VALIDATION_FAIL: "PIN-s\xF6kningen m\xE5ste vara mellan 6 och 17 tecken",
  SEARCH_PRODUCT_BY_PIP_PLACEHOLDER: "Ange PIP-nummer, minst 4 tecken",
  SEARCH_PRODUCT_BY_PIP_VALIDATION_FAIL: "PIP-s\xF6kningen m\xE5ste vara mellan 4 och 12 tecken",
  SEARCH_RESULTS_TAB: "S\xF6kresultat ({count})",
  SECOND_SHIP_TO_LOCATION: "Andra leverans till plats",
  SELECT: "V\xE4lj",
  SELECT_A_RANGE: "V\xE4lj en grupp",
  SELECT_ALL: "V\xE4lj alla",
  SELECT_AUTO_SUBMIT: "V\xE4lj Auto Submit (skicka automatiskt)",
  SELECT_BRANCH: "V\xE4lj f\xF6rgrening",
  SELECT_CLAIM_TYPE: "V\xE4lj anspr\xE5kstyp",
  SELECT_CLAIMS: "V\xE4lj anspr\xE5k",
  SELECT_CLAIMS_WITHIN_DATE_RANGE: "V\xE4lj anspr\xE5k inom datumintervall",
  SELECT_COLUMNS: "V\xE4lj kolumner",
  SELECT_COUNTRY: "V\xE4lj land",
  SELECT_CSV_SEPARATOR: "V\xE4lj CSV-separator",
  SELECT_DATE_FORMAT: "V\xE4lj datumformat",
  SELECT_DEALERS_AND_STATUS: "V\xE4lj \xC5terf\xF6rs\xE4ljare och status",
  SELECT_DECIMAL_FORMAT: "V\xE4lj decimalformat",
  SELECT_DISPLAY_FORMAT: "V\xE4lj displayformat",
  SELECT_FACTORY: "V\xE4lj fabrik",
  SELECT_LANGUAGE: "V\xE4lj spr\xE5k",
  SELECT_LAYOUT: "V\xE4lj layout",
  SELECT_NEW_CLAIMS: "V\xE4lj nya anspr\xE5k",
  SELECT_PIP_CODE: "V\xE4lj PIP-kod",
  SELECT_PLAN_NAMES: "V\xE4lj Plannamn",
  SELECT_SERVICE_INTERVAL_TYPES: "V\xE4lj serviceintervallstyper",
  SELECT_SORT_BY: "V\xE4lj Sortera efter",
  SELECT_SORT_DIRECTION: "V\xE4lj Sorteringsriktning",
  SELECT_STATE: "V\xE4lj status",
  SELECT_STATUS: "V\xE4lj status",
  SELECT_TERRITORY: "V\xE4lj omr\xE5de",
  SELECT_THEME: "V\xE4lj tema",
  SELECT_TIME_ZONE: "V\xE4lj tidszon",
  SELECT_VALUES_TO_APPROVE: "V\xE4lj v\xE4rden som ska godk\xE4nnas",
  SELECTED_COLUMNS: "Valda kolumner",
  SELECTED_FOR_AUDIT: "Vald f\xF6r granskning",
  SELECTED_FOR_AUDIT_VSR: "Se DTAC-l\xF6sning 221475 f\xF6r den revisionsdokumentation och de bilagor som kr\xE4vs f\xF6r detta anspr\xE5k",
  SELECTING_MULTIPLE_ACCOUNTS_AND_WARRANTY_TYPES_IMPACTS_PERFORMANCE: "Val av flera konton och garantityper p\xE5verkar prestationen",
  SEND: "Skicka",
  SERIAL_NUMBER: "Serienummer",
  SERIAL_NUMBER_INVOICE_NUMBER: "Serienummer/fakturanummer",
  SERVER_TOOK_TOO_LONG_TO_REPLY: "Servern tog f\xF6r l\xE5ng tid att svara och beg\xE4ran har annullerats. F\xF6rs\xF6k med en mer specifik f\xF6rfr\xE5gan eller f\xF6rs\xF6k igen senare.",
  SERVICE_DATE_IS_REQUIRED: "Servicedatum kr\xE4vs",
  SERVICE_INTERVAL: "Serviceintervall",
  SERVICE_INTERVAL_BEGIN_DATE: "Startdatum f\xF6r serviceintervall",
  SERVICE_INTERVAL_END_DATE: "Slutdatum f\xF6r serviceintervall",
  SERVICE_INTERVAL_IS_REQUIRED: "Serviceintervall kr\xE4vs",
  SERVICE_INTERVAL_NUMBER: "Serviceintervallnummer",
  SERVICE_INTERVAL_STATUS: "Status f\xF6r serviceintervall",
  SERVICE_INTERVAL_TYPE: "Typ av serviceintervall",
  SERVICE_INTERVAL_TYPES: "Serviceintervaller",
  SERVICE_PART: "Servicedel",
  SERVICE_UNAVAILABLE: "Service ej tillg\xE4nglig",
  SERVICED: "Service",
  SERVICED_DATE_IS_REQUIRED: "Servicedatum kr\xE4vs",
  SERVICED_IS_REQUIRED: "Service kr\xE4vs.",
  SET_AS_DEFAULT: "St\xE4ll in som standard",
  SETTINGS: "Mina inst\xE4llningar",
  SETTLED: "L\xF6st",
  SETTLEMENT_NO_REGISTRATION: "Avveckling, ingen registrering",
  SETUP: "Inst\xE4llning",
  SETUP_DATE_IS_REQUIRED: "Inst\xE4llningsdatum kr\xE4vs",
  SETUP_IS_REQUIRED: "Inst\xE4llning kr\xE4vs",
  SGST_UTGST: "SGST/UTGST",
  SHIP_TO: "Leverera till",
  SHIPPED: "Levererad",
  SHIPPING_INFORMATION_SPECIAL_INSTRUCTIONS: "Fraktinformation/s\xE4rskilda anvisningar",
  SHIPPING_INSTRUCTIONS: "Fraktanvisningar",
  SHORT_TEXT: "Kort text",
  SHORT_TEXT_IS_REQUIRED: "Kort text kr\xE4vs",
  SHOW_ALL: "Visa alla ({count})",
  SHOW_EXCLUDED: "Visa utesluten",
  SHOW_MORE: "Visa mer",
  SHOW_MORE_GROUPS: "Visa {countToDisplay} fler {count, plural, one {group} andra {group}",
  SHOW_RED_IF_LESS_THAN: "Visa r\xF6tt om det \xE4r mindre \xE4n",
  SHOW_REIMBURSED_AMOUNT: "Visa \xE5terbetalt belopp",
  SHOW_REIMBURSED_PERCENTAGE: "Visa \xE5terbetald procentandel",
  SHOW_YELLOW_IF_LESS_THAN: "Visa gul om den \xE4r mindre \xE4n",
  SIGN_IN_REQUIRED: "Inloggning kr\xE4vs",
  SIGN_OUT: "Logga ut",
  SKIP_AUDIT: "Hoppa \xF6ver granskning",
  SKIP_AUDIT_SUCCESS: "Granskningen har hoppats \xF6ver och f\xF6rfallodatumet \xE4r nu inne i framtiden.",
  SOME_PARTS_RETURNED: "Vissa delar returnerade",
  SORT_BY: "Sortera efter",
  SPANISH: "Spanska",
  SPECIAL_ALLOWANCE: "S\xE4rskild ers\xE4ttning",
  SPECIAL_ALLOWANCE_CALCULATION: "Ber\xE4kning av specialutsl\xE4ppsr\xE4tter",
  SPECIAL_ALLOWANCE_CLAIM: "S\xE4rskild ers\xE4ttning",
  SPECIAL_ALLOWANCE_CLAIM_STATUS: "Status f\xF6r anspr\xE5k om s\xE4rskild ers\xE4ttning",
  SPECIAL_ALLOWANCE_CLAIM_STATUS_TABM: "Status f\xF6r anspr\xE5k om s\xE4rskild ers\xE4ttning",
  SPECIAL_ALLOWANCE_CLAIM_STATUS_UPDATED: "Status f\xF6r anspr\xE5k om s\xE4rskild ers\xE4ttning uppdaterad",
  SPECIAL_ALLOWANCE_CLAIM_WITH_ID: "Specialanspr\xE5k - {anspr\xE5kNumber}",
  SPECIAL_ALLOWANCE_CLAIMS_WITH_COUNT: "Specialanspr\xE5k ({count})",
  SPECIAL_ALLOWANCE_CONTRIBUTIONS: "S\xE4rskilda bidrag",
  SPECIAL_ALLOWANCE_DESCRIPTION: "Beskrivning av specialutsl\xE4ppsr\xE4tter",
  SPECIAL_ALLOWANCE_TYPE: "Typ av specialbidrag",
  SPECIAL_ALLOWANCE_TYPE_IS_REQUIRED: "S\xE4rskild bidragstyp kr\xE4vs",
  SPECIAL_INSTRUCTIONS: "S\xE4rskilda anvisningar",
  SPG: "SPG",
  SPGS: "SPG",
  STANDARD_VIEW: "Standardvy",
  START_AMOUNT_OF_USE: "Startm\xE4ngd",
  STARTS: "Startar",
  STARTS_WITH: "B\xF6rjar med",
  STATE: "stat",
  STATE_PROVINCE: "Stat/provins",
  STATE_PROVINCE_REQUIRED: "Status/provins kr\xE4vs",
  STATUS: "Status",
  STATUS_CHANGE_REQUEST: "Beg\xE4ran om \xE4ndring av status",
  STATUS_CHANGE_REQUEST_CREATED_SUCCESSFULLY: "Beg\xE4ran om status\xE4ndring har skapats",
  STATUS_FOR: "Status f\xF6r {pin}",
  STATUS_INDICATOR: "Statusindikator",
  STATUS_REASON: "Statusorsak",
  STOLEN_DATE: "Slutdatum",
  STORE: "F\xF6rvaring",
  STORE_IS_REQUIRED: "F\xF6rvaring kr\xE4vs",
  STORE_NUMBER_IS_REQUIRED: "Lagringsnummer kr\xE4vs",
  STREET_1: "Gatuadress 1",
  STREET_2: "Street 2",
  SUB: "Skicka",
  SUB_CLAIM_TYPE: "Underfordringstyp",
  SUB_TYPE: "Undertyp",
  SUBMISSION_DATE: "Inl\xE4mningsdatum",
  SUBMIT: "Skicka",
  SUBMIT_AUDIT: "Skicka in granskning",
  SUBMIT_AUDIT_FOR: "Skicka in granskning f\xF6r {dealer}",
  SUBMIT_FULL_DEBIT_CLAIM_FOR_WITH_CLAIM_NUMBER: "Skicka in en fullst\xE4ndig anspr\xE5k f\xF6r {anspr\xE5kNumber}",
  SUBMIT_PARTIAL_DEBIT_CLAIM_FOR_WITH_CLAIM_NUMBER: "Skicka in en partiell debetanspr\xE5k f\xF6r {anspr\xE5kNumber}",
  SUBMIT_PERCENTAGE_DEBIT_CLAIM_FOR_WITH_CLAIM_NUMBER: "Skicka in procentdebetanspr\xE5k f\xF6r {anspr\xE5kNumber}",
  SUBMIT_REQUEST: "Skicka beg\xE4ran",
  SUBMITTED: "Inl\xE4mnad",
  SUBMITTED_AVAILABLE_TO_EDIT: "Inskickat (redigerbart)",
  SUCCESS: "Framg\xE5ng",
  SUCCESS_MESSAGE_TITLE: "En \xE5tg\xE4rd lyckades:",
  SUCCESS_MESSAGES_TITLE: "Flera arbeten lyckades:",
  SUPPLIER_WARRANTY: "Leverant\xF6rsgaranti",
  SURVEY_QUESTIONS: "Unders\xF6kningsfr\xE5gor",
  SUSPENDED: "Upph\xE4ngd",
  SWEDISH: "Svenska",
  SYSTEM_SELECTED_CLAIMS: "Systemvalda anspr\xE5k",
  SYSTEM_SELECTED_CLAIMS_WITH_COUNT: "Systemvalda anspr\xE5k ({count})",
  TABM: "BORD",
  TAX: "Skatt",
  TCSM: "TCSM",
  TECH_ID: "Teknisk ID",
  TERMINATED: "Avslutad",
  TERMINATES: "Avslutningar",
  TERRITORY: "Omr\xE5de",
  TEST: "Prov",
  TEST_RESULTS_CODE: "Testresultatkod",
  THEME: "Tema",
  TIME_LIMIT: "Tidsgr\xE4ns",
  TIME_ZONE: "Tidszon",
  TITLE: "Titel",
  TITLE_IS_REQUIRED: "Titel kr\xE4vs",
  TO: "Till",
  TODAY: "Idag",
  TOO_MANY_RESULTS: "Din f\xF6rfr\xE5gan gav f\xF6r m\xE5nga resultat. Begr\xE4nsa dina s\xF6kord och f\xF6rs\xF6k igen.",
  TOTAL: "Totalt",
  TOTAL_AMOUNT: "Totalt belopp",
  TOTAL_APPROVED: "Totalt godk\xE4nt",
  TOTAL_APPROVED_CLAIM_VALUE: "Totalt godk\xE4nt anspr\xE5ksv\xE4rde",
  TOTAL_APPROVED_INCLUDING_TAXES: "Totalt godk\xE4nt inklusive skatter",
  TOTAL_APPROVED_WITHOUT_ADDITIVES: "Totalt godk\xE4nt utan tillsatser",
  TOTAL_CONTRIBUTION: "Totalt bidrag",
  TOTAL_REIMBURSED: "\xC5terbetald summa",
  TOTAL_REIMBURSED_WITH_CURRENCY: "\xC5terbetald summa ({valuta})",
  TOTAL_REQUESTED: "Totalt beg\xE4rt",
  TOTAL_REQUESTED_CLAIM_VALUE: "Totalt beg\xE4rt anspr\xE5ksv\xE4rde",
  TOTAL_UNPAID: "Summa obetalda belopp",
  TRACKING_NUMBER: "Sp\xE5rnummer",
  TRANSFER: "\xD6verf\xF6ring",
  TRANSFER_APPROVALS: "\xD6verf\xF6ringsgodk\xE4nnanden",
  TRANSFER_APPROVALS_TAB: "\xD6verf\xF6r godk\xE4nnanden ({count})",
  TRANSFER_CREATED: "\xD6verf\xF6ring skapad",
  TRANSFER_DEALER_RECOMMENDATIONS: "Vill du \xF6verf\xF6ra n\xE5len till en annan \xE5terf\xF6rs\xE4ljare?",
  TRANSFER_UPDATED_SUCCESSFULLY: "\xD6verf\xF6ringen har uppdaterats",
  TRANSFERS: "\xD6verf\xF6ringar",
  TRAVEL: "Resor",
  TURKISH: "turkiska",
  TWO_PERCENT_WITHHOLD_VALUE: "2 % inneh\xE5lls v\xE4rde",
  TYPE: "Typ",
  TYPES: "Typer",
  UNABLE_TO_CONTACT_THE_SERVER: "Det g\xE5r inte att kontakta servern",
  UNABLE_TO_LOAD_CUSTOMER_DETAILS: "Det g\xE5r inte att ladda kunddetaljer",
  UNDO: "\xC5ngra",
  UNDO_REGISTRATION: "\xC5ngra registrering",
  UNDO_REGISTRATION_SUCCESSFULL: "\xC5ngra-registreringen lyckades",
  UNIT: "Enhet",
  UNIT_1: "Enhet 1",
  UNIT_2: "Enhet 2",
  UNIT_3: "Enhet 3",
  UNIT_OF_MEASURE: "M\xE5ttenhet",
  UNPAID_LABOR: "Obetalt arbete",
  UNPAID_LABOR_ADDITIVES_EXCLUDING_PIPS: "Obetalda till\xE4gg av arbete - exklusive produktf\xF6rb\xE4ttringsprogram",
  UNPAID_LABOR_ADDITIVES_PIPS: "Obetalda till\xE4gg av arbete - PIP:er",
  UNPAID_OTHER_CREDITS: "Obetalda andra krediter",
  UNPAID_PARTS: "Obetalda delar",
  UNPAID_PARTS_ADDITIVE: "Obetalda reservdelstill\xE4gg",
  UNPAID_TRAVEL: "Obetalda resor",
  UNSUB: "Ta bort",
  UNSUBMIT_CLAIM: "Ta bort anspr\xE5k",
  UPDATE_CUSTOMER_INFORMATION: "Uppdatera kundinformation",
  UPDATE_LABOR_RATES: "Uppdatera arbetshastigheter",
  UPDATE_LAYOUT: "Uppdatera layout",
  UPDATE_MACHINE_STATUS: "Uppdatera maskinstatus",
  UPDATE_MACHINE_STATUS_HISTORY: "Uppdatera maskinstatushistorik",
  UPDATE_REGISTRATION: "Uppdatera registrering",
  UPDATE_SELECTED: "Uppdatera vald",
  UPDATED: "Uppdaterad",
  UPDATED_BY: "Uppdaterad av",
  UPLOAD_DOCUMENT: "Ladda upp dokument",
  UPTIME_ASSURANCE: "Aktiv k\xF6rtid",
  USEFUL_LINKS: "Anv\xE4ndbara l\xE4nkar",
  USER: "anv\xE4ndare",
  USER_PREFERENCES_UPDATED: "Anv\xE4ndarpreferenser uppdaterade",
  USER_SELECTED: "Vald anv\xE4ndare",
  USER_SELECTED_CLAIMS_WITH_COUNT: "Anv\xE4ndarvalda anspr\xE5k ({count})",
  USERS_INFORMATION: "Anv\xE4ndarinformation",
  VALIDATE: "Validera",
  VALIDATE_CLAIM: "Validera anspr\xE5k",
  VALUE: "V\xE4rde",
  VALUE_OF_REPAIR: "Reparationsv\xE4rde",
  VIEW_CLAIM: "Visa anspr\xE5k",
  VIEW_DETAILS: "Visa detaljer",
  VIEW_OPEN_PIPS: "Visa \xF6ppna PIP:er",
  VIEW_PIP: "Visa PIP",
  VIEW_PRODUCTS: "Visa produkter",
  VIEW_PRODUCTS_AND_UPDATE_INFO: "Visa produkter och uppdatera information",
  VIEW_UPDATE: "Visa/uppdatera",
  VSR_MESSAGES: "VSR-meddelanden",
  WAITING_FOR_DLR_INV: "V\xE4ntar p\xE5 \xE5terf\xF6rs\xE4ljarfaktura",
  WAITING_FOR_INVOICE: "V\xE4ntar p\xE5 faktura ({count})",
  WAITING_SINCE: "V\xE4ntar sedan",
  WARNING_MESSAGE_TITLE: "En varning skickades:",
  WARNING_MESSAGES: "Varningsmeddelanden",
  WARNING_MESSAGES_TITLE: "Flera varningar skickades:",
  WARRANTY: "Garanti",
  WARRANTY_ADMIN: "Garantiadmin",
  WARRANTY_CLAIM_TYPE: "Garantianspr\xE5kstyp",
  WARRANTY_COVERAGE: "Garantit\xE4ckning",
  WARRANTY_EXPIRATION: "Garantin utg\xE5r",
  WARRANTY_TYPE: "Garantityp",
  WARRANTY_TYPES: "Garantityper",
  WEAR_PARTS: "Slitdelar",
  WEAR_PARTS_COVERAGE: "T\xE4ckning f\xF6r slitdelar",
  WELCOME: "V\xE4lkommen",
  WIP: "Arbete p\xE5g\xE5r",
  WITH_ADDITIVES: "Med tillsatser",
  WITNESS_FIRST_NAME: "Upplev f\xF6rnamn",
  WITNESS_LAST_NAME: "Efternamn f\xF6r vittne",
  WORK_ORDER: "Arbetsorder",
  WORK_ORDER_NUMBER: "Arbetsordernummer",
  WORK_ORDER_ONE: "Arbetsorder 1",
  WORK_ORDER_ONE_IS_REQUIRED: "Arbetsorder 1 kr\xE4vs",
  WORK_ORDER_THREE: "Arbetsorder 3",
  WORK_ORDER_THREE_IS_REQUIRED: "Arbetsorder 3 kr\xE4vs",
  WORK_ORDER_TWO: "Arbetsorder 2",
  WORK_REPAIR_ORDER: "Best\xE4llning av reparation av arbete",
  YES: "JA",
  YES_LOWERCASE: "Ja"
});